import React, { useState, useEffect, useMemo, useContext, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import UserService from '../../Services/user.service.js';
import ClientService from '../../Services/client.service.js';
import PaymentService from '../../Services/payment.service.js';
import CaseRelationshipService from '../../Services/caseRelationship.service.js';
import AuthService from '../../Services/auth.service.js';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ToastContainer, toast } from "react-toastify";
import { useSignalR } from '../../Contexts/signalR.js';
import ClientDocumentCountService from '../../Services/ClientDocumentCount.service.js';
import clientsIcon from "../../assests/images/Main/clients.svg";
import subAccountantsIcon from "../../assests/images/Main/subAccountants.svg";
import SubAccountantService from '../../Services/subAccountant.service.js';
import loadingAnimation from "../../assests/images/Animation.gif";
import Constants from '../../assests/Constants/constants.js';
import CircularProgress from '@mui/material/CircularProgress';
import Divider from '@mui/material/Divider';
import PuffLoader from "react-spinners/PuffLoader";
import { beautifyNumber } from '../../Utils/FormatNumber.js';
import { TextField, IconButton, InputAdornment, Checkbox, FormControlLabel, Typography, Button, Box } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import Select from 'react-select';
import ProfileSignatureDialog from '../../Components/Widgets/ProfileSignatureDialog/ProfileSignatureDialog.jsx';
import ClientNotesEditor from '../../Components/ClientDetails/SubComponents/ClientDataTable/ClientNotesEditor.jsx';
import Styles from './AddClient.module.scss';
import { PermissionsContext } from '../../Contexts/Permissions.js';
import PermissionService from '../../Services/permission.service.js';
import { el } from 'date-fns/locale';
import { validateEmail, validatePhoneNumber, formatIsraeliPhoneNumber, normalizeIsraeliPhoneNumberForStorage } from '../../Utils/helpers.js';
import { NavHistoryContext } from '../../Contexts/NavHistoryContext.js';
import { format } from 'date-fns';
import { arSA, enGB, he } from 'date-fns/locale';
import CustomDatePicker from '../../Components/Widgets/CustomDates/CustomDatePicker/CustomDatePicker.js';
import { styledInput } from '../../Utils/styledInputHelper.js';
import SwitchPayerModal from '../../Components/payments/SwitchPayerModal.jsx';
import RequestTransferModal from '../../Components/payments/RequestTransferModal.jsx';
import PasswordDialog from '../../Components/Main/PasswordDialog.jsx';
import InitialClientPasswordModal from '../../Components/Main/InitialClientPasswordModal.jsx';
import PartnersManagementModal from '../../Components/PartnersManagementModal/PartnersManagementModal.jsx';
import Swal from 'sweetalert2';
import { INDUSTRY_OPTIONS } from '../../assests/Constants/industryOptions.js';
import { invalidateMainPageCache } from '../../Utils/cacheManager.js';
import deleteIcon from '../../assests/images/Icons/deleteIcon.svg';
import DeleteUserDialog from '../../Components/ClientDetails/SubComponents/ModalsSection/DeleteUserDialog.jsx';
import config from '../../config';
import selectedEnvironment from '../../env';
import ClientBlockerWindow from '../../Components/ClientBlockerWindow/ClientBlockerWindow.jsx';
import YearlyTaxAdvanceModal from '../../Components/Widgets/YearlyTaxAdvanceModal/YearlyTaxAdvanceModal.jsx';
const localeMap = {
    ar: arSA,
    en: enGB,
    he: he
};

const logPayerCard = (...args) => {
    if (typeof console !== 'undefined' && console.log) {
        console.log('[Xtram payer/card]', ...args);
    }
};

// Dedupes initial bootstrap across React Strict Mode double-mount (refs reset on remount; this does not).
let addClientBootstrapPromise = null;

const AddClient = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { i18n, t } = useTranslation();
    const [user, setUser] = useState();
    const [token, setToken] = useState();
    const [searchQuery, setSearchQuery] = useState('');
    const [loading, setLoading] = useState(false);
    const { client, isEdit } = location.state || {};
    const [subAccountants, setSubAccountants] = useState([]);
    const [direction, setDirection] = useState('rtl'); // Default to 'rtl'
    const { permissions, permissionsState, loading: permissionsLoading, userTypeContext } = useContext(PermissionsContext);
    const userTypeContextRef = useRef(userTypeContext);
    userTypeContextRef.current = userTypeContext;
    const { goBack } = useContext(NavHistoryContext);
    // Leading-business state
    const [isLeadingBusiness, setIsLeadingBusiness] = useState(false);  // this client’s flag
    const [isManagingInventory, setIsManagingInventory] = useState(false);  // this client’s flag
    const [showSwitchModal, setShowSwitchModal] = useState(false);
    const pendingPayerSwitchRef = useRef(null); // { previousPaymentMethod }
    const [otherLeadingExists, setOtherLeadingExists] = useState(false);  // some *other* client already leading
    const [partnersModalOpen, setPartnersModalOpen] = useState(false);
    const [partners, setPartners] = useState([]);
    const [caseRelationshipModalOpen, setCaseRelationshipModalOpen] = useState(false);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [itemIdToDelete, setItemIdToDelete] = useState(null);
    const [isClientActive, setIsClientActive] = useState(true);
    const [caseRelationship, setCaseRelationship] = useState({
        isSharedReporting: false,
        relationshipType: '',
        relatedCaseId: ''
    });
    const [existingRelationshipData, setExistingRelationshipData] = useState(null);
    const [availableClients, setAvailableClients] = useState([]);
    const [transferModalOpen, setTransferModalOpen] = useState(false);

    const MONTHLY_HE = "חודשי";

    const translatedClientPaymentMethodOptions = Constants.clientPaymentMethodOptions.map(option => ({
        value: option.value,
        label: t(option.label),
        name: t(option.label)
    }));

    const translatedPackageOptions = Constants.packageOptions.map(option => ({
        value: option.value,
        label: t(option.label),
        name: t(option.label)
    }));

    /** Who is billed for the Finsite bank-import service once the client pays for itself. */
    const finsitePayerOptions = [
        { value: false, label: t('FinsitePayerAccountant'), name: t('FinsitePayerAccountant') },
        { value: true, label: t('FinsitePayerClient'), name: t('FinsitePayerClient') },
    ];

    const [formData, setFormData] = useState({
        bank: {
            bankCode: '',
            branchNumber: '',
            accountNumber: '',
            paymentMethod: 0
        },
        CaseID: '',
        ClientID: '',
        taxClientNumber: '',
        vatClientNumber: '',
        deductionsCase: '',
        ClientName: '',
        businessOwnerName: '',
        spouseName: '',
        businessEstablishmentDate: '',
        ClientPhoneNumber: '',
        ClientSecondaryPhoneNumber: '',
        ClientNotes: '',
        ClientLocation: '',
        ClientEmail: '',
        ClientWebsite: '',
        incomeTaxAdvancePercentage: '',
        useIncomeTaxAdvancePercentage: true,
        ClientReportingType: '',
        AccountManagement: '',
        CaseType: '',
        showVatPanelForTaxExempt: false,
        subAccId: '',
        incomeTaxAdvanceAmount: '',
        taxAssessor: '',
        signature: '',
        profilePicture: '',
        taxCreditPoints: 0,
        clientPaymentMethod: Constants.clientPaymentMethodOptionsEnum.Accountant,
        package: Constants.packageOptionsEnum.Basic,
        advancedReportingType: "",
        officeIdentifyNumber: null,
        leadingBusiness: false,
        managesInventory: false,
        managesProject: false,
        finsitePaidByClient: false,
        isPartners: false,
        isRequiredToReportPCN874: false,
        canSeeVat: true,
        canSeeDocumentStatus: true,
        manageOnly: false,
        taxRefund: false,
        businessField: null,
        businessType: -1,
        economicBusinessBranch: '',
        isSharedReporting: false,
        relationshipType: '', // 'main' or 'subordinate'
        relatedCaseId: '', // Single case ID for the relationship
        sendWelcomeEmail: false,
        sendWelcomeWhatsApp: false,
        sendDocumentsInfoEmail: false,
        sendDocumentsInfoWhatsApp: false,
        welcomePasswordForNotification: '',


    });
    /** Payer as loaded from server (edit). Navigation `client` often omits `clientPaymentMethod`; this is set in fetchPackagePermission. */
    const [serverOriginalClientPaymentMethod, setServerOriginalClientPaymentMethod] = useState(null);
    /**
     * ManageOnly permission as loaded from server (edit). Used to enforce the one-way rule:
     * a client that was ManageOnly may be downgraded to regular, but a regular client can never
     * be promoted to ManageOnly. Basing the lock on this original value (not the live form value)
     * also prevents the toggle "cycle" where a ManageOnly client switched to regular within the
     * same session could be silently blocked from switching back.
     */
    const [originalManageOnly, setOriginalManageOnly] = useState(false);
    /** TaxRefund (always together with ManageOnly) as loaded from server (edit). */
    const [originalTaxRefund, setOriginalTaxRefund] = useState(false);
    const isVatExempt = Constants.TaxExemptTypes.includes(formData.CaseType);


    useEffect(() => {
        const shouldSeeVat = !isVatExempt;          // exempt ⇒ false  |  regular ⇒ true
        if (formData.canSeeVat !== shouldSeeVat) {
            handleChange('canSeeVat', shouldSeeVat);
        }

        if (isVatExempt) {
            handleChange("ClientReportingType", MONTHLY_HE);
            handleChange("advancedReportingType", MONTHLY_HE);
        }
    }, [isVatExempt]);

    const [officePwd, setOfficePwd] = useState({
        isHave: isEdit ? !!client?.isHaveOfficePassword : false,   // checkbox
        value: "",                                                // secret typed in dialog
        existsOnServer: isEdit ? !!client?.isHaveOfficePassword : false,
    });
    const [officePwdDialogOpen, setOfficePwdDialogOpen] = useState(false);
    const caseIdIsValid = /^\d{9,10}$/.test(String(formData.CaseID || ''));
    // ManageOnly / TaxRefund clients only use CRM + Archive, so the form shows a reduced field set
    // and the hidden VAT / income-tax selects are not required.
    const isLimitedClient = !!formData.manageOnly;

    /** False while client still uses CaseId-derived initial password (edit + Show Password). */
    const [hasChangedInitialPassword, setHasChangedInitialPassword] = useState(
        isEdit ? (client?.hasChangedInitialPassword !== false) : false
    );
    const [initialPasswordModalOpen, setInitialPasswordModalOpen] = useState(false);
    const [initialPasswordValue, setInitialPasswordValue] = useState('');
    const [initialPasswordModalAfterCreate, setInitialPasswordModalAfterCreate] = useState(false);
    const pendingNavigateAfterPasswordRef = useRef(false);

    const caseIdDigits = String(formData.CaseID || '').replace(/\D/g, '');
    const isCaseIdValidForInitialPassword = caseIdDigits.length === 9 || caseIdDigits.length === 10;

    const allFieldsFilled = (isEdit ? formData.CaseID : caseIdIsValid) &&
        formData.ClientID &&
        formData.ClientName &&
        (isEdit || isCaseIdValidForInitialPassword) &&
        formData.ClientPhoneNumber &&
        validatePhoneNumber(formData.ClientPhoneNumber) &&
        (!formData.ClientEmail || formData.ClientEmail === '' || validateEmail(formData.ClientEmail)) && // Use existing email validation
        formData.CaseType &&
        (isLimitedClient || (
            formData.ClientReportingType &&
            formData.advancedReportingType &&
            formData.AccountManagement &&
            (!formData.isSharedReporting || formData.relationshipType) && // Case relationship validation
            (!formData.isSharedReporting || formData.relatedCaseId)
        ));



    const accountingManagementType = useMemo(() => {
        return Constants.AccountManagementOptions?.map(option => ({
            value: option.name,
            label: option.name,
        }));
    }, [Constants.AccountManagementOptions]);

    const [accountOptionSelected, setAccountOptionSelected] = useState(() => {
        const savedValues = JSON.parse(localStorage.getItem('accountOptionSelected') || '[]');
        return savedValues;
    });

    const [openSignatureDialog, setOpenSignatureDialog] = useState(false);
    const baselineClientPaymentMethod =
        serverOriginalClientPaymentMethod ??
        client?.clientPaymentMethod ??
        client?.ClientPaymentMethod ??
        null;

    const payerSwitched = useMemo(() => {
        return (
            isEdit &&
            baselineClientPaymentMethod === Constants.clientPaymentMethodOptionsEnum.Accountant &&
            formData.clientPaymentMethod === Constants.clientPaymentMethodOptionsEnum.Client
        );
    }, [isEdit, baselineClientPaymentMethod, formData.clientPaymentMethod, serverOriginalClientPaymentMethod, client?.clientPaymentMethod]);

    // Switching from Client (business) to Accountant payer – may need to pay unpaid balance first
    const switchingToAccountant = useMemo(() => {
        return (
            isEdit &&
            baselineClientPaymentMethod === Constants.clientPaymentMethodOptionsEnum.Client &&
            formData.clientPaymentMethod === Constants.clientPaymentMethodOptionsEnum.Accountant
        );
    }, [isEdit, baselineClientPaymentMethod, formData.clientPaymentMethod, serverOriginalClientPaymentMethod, client?.clientPaymentMethod]);

    const [showClientBlockerForEdit, setShowClientBlockerForEdit] = useState(false);
    const [yearlyTaxAdvanceModalOpen, setYearlyTaxAdvanceModalOpen] = useState(false);
    const pendingClientDataRef = useRef(null);



    const [optionSelected, setOptionSelected] = useState(() => {
        const savedOptions = localStorage.getItem('optionSelected');
        return savedOptions ? JSON.parse(savedOptions) : [];
    });

    useEffect(() => {
        localStorage.setItem('optionSelected', JSON.stringify(optionSelected));
    }, [optionSelected]);



    const handleAccManagmentChange = (event, newValue) => {
        setAccountOptionSelected(newValue);
        localStorage.setItem('accountOptionSelected', JSON.stringify(newValue));
    };

    const handleSubAccChange = (event, newValue) => {
        setOptionSelected(newValue);
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const isRtl = ['he', 'ar'].includes(i18n.language);
    const fetchSubAccountantsData = async (accountantId, token, isFirstFetch, accountantOption = null) => {
        try {
            setLoading(true);
            const data = permissionsState.ViewSubAccountantClients ? await SubAccountantService.GetSubAccountantByAccountantIdForClients(token, accountantId) : await SubAccountantService.GetSubAccountantByAccountantId(token, accountantId);
            if (isFirstFetch) {
                let transformedData = data.map(item => ({
                    label: item.name,
                    value: item.subAccountantId
                }));
                if (accountantOption?.value) {
                    const exists = transformedData.some((x) => x.value === accountantOption.value);
                    if (!exists) {
                        transformedData = [accountantOption, ...transformedData];
                    }
                }
                setSubAccountants(transformedData);
            } else {
                setSubAccountants([...subAccountants, ...data]);
            }
        } catch (error) {
            console.error(error);
            toast.error(t('fetchSubAccountantsDataError'));
        }
        setLoading(false);
    };

    const fetchAvailableClients = async (token, accountantId) => {
        try {
            const data = await ClientService.GetMinimalClients(accountantId, token, 1, 1000, true);
            const clients = data.clients;

            const filteredClients = isEdit ? clients.filter(client => client.caseId !== formData.CaseID) : clients;
            setAvailableClients(filteredClients);

        } catch (error) {
            console.error('Error fetching clients:', error);
            toast.error(t('ErrorFetchingClients'));
        }
    };

    const fetchCaseRelationships = async (caseId, token) => {
        try {
            const relationships = await CaseRelationshipService.GetCaseRelationshipsByCaseId(token, caseId);
            if (relationships && relationships.length > 0) {
                const mainRelationship = relationships.find(r => r.mainCaseId === caseId);
                const subordinateRelationship = relationships.find(r => r.subordinateCaseId === caseId);

                if (mainRelationship) {
                    handleChange('isSharedReporting', true);
                    handleChange('relationshipType', 'main');
                    handleChange('relatedCaseId', relationships[0].subordinateCaseId);
                    setExistingRelationshipData({
                        id: mainRelationship.id,
                        type: 'main',
                        relatedCaseId: relationships[0].subordinateCaseId,
                        relatedCaseName: availableClients.find(c => c.caseId === relationships[0].subordinateCaseId)?.name || relationships[0].subordinateCaseId
                    });
                } else if (subordinateRelationship) {
                    handleChange('isSharedReporting', true);
                    handleChange('relationshipType', 'subordinate');
                    handleChange('relatedCaseId', subordinateRelationship.mainCaseId);
                    setExistingRelationshipData({
                        id: subordinateRelationship.id,
                        type: 'subordinate',
                        relatedCaseId: subordinateRelationship.mainCaseId,
                        relatedCaseName: availableClients.find(c => c.caseId === subordinateRelationship.mainCaseId)?.name || subordinateRelationship.mainCaseId
                    });
                }
            } else {
                setExistingRelationshipData(null);
            }
        } catch (error) {
            console.error('Error fetching case relationships:', error);
        }
    };

    const handleCaseRelationships = async (token, caseId, isEdit) => {
        if (!formData.isSharedReporting) {
            // If shared reporting is disabled, delete any existing relationships
            if (isEdit) {
                try {
                    const existingRelationships = await CaseRelationshipService.GetCaseRelationshipsByCaseId(token, caseId);
                    if (existingRelationships) {
                        for (const relationship of existingRelationships) {
                            await CaseRelationshipService.DeleteCaseRelationship(token, relationship.id);
                        }
                    }
                } catch (error) {
                    console.error('Error deleting existing relationships:', error);
                }
            }
            return;
        }

        try {
            if (isEdit) {
                // Delete existing relationships first
                const existingRelationships = await CaseRelationshipService.GetCaseRelationshipsByCaseId(token, caseId);
                if (existingRelationships) {
                    for (const relationship of existingRelationships) {
                        await CaseRelationshipService.DeleteCaseRelationship(token, relationship.id);
                    }
                }
            }

            if (formData.relationshipType === 'main' && formData.relatedCaseId) {
                // Create relationship for main case
                const relationshipData = {
                    mainCaseId: caseId,
                    subordinateCaseId: formData.relatedCaseId
                };
                await CaseRelationshipService.CreateCaseRelationship(token, relationshipData);
            } else if (formData.relationshipType === 'subordinate' && formData.relatedCaseId) {
                // Create relationship for subordinate case
                const relationshipData = {
                    mainCaseId: formData.relatedCaseId,
                    subordinateCaseId: caseId
                };
                await CaseRelationshipService.CreateCaseRelationship(token, relationshipData);
            }
        } catch (error) {
            console.error('Error handling case relationships:', error);
            toast.error(t('ErrorSavingCaseRelationships'));
        }
    };

    const handleRemoveRelationship = async () => {
        if (!existingRelationshipData?.id || !token) return;
        try {
            await CaseRelationshipService.DeleteCaseRelationship(token, existingRelationshipData.id);
            setExistingRelationshipData(null);
            handleChange('isSharedReporting', false);
            handleChange('relationshipType', '');
            handleChange('relatedCaseId', '');
            toast.success(t('RelationshipRemovedSuccessfully') || 'Relationship removed successfully');
        } catch (error) {
            console.error('Error removing relationship:', error);
            toast.error(t('ErrorRemovingRelationship') || 'Error removing relationship');
        }
    };

    useEffect(() => {
        // After user+token are loaded once, we don't re-run the initial fetch.
        if (user && token) return;

        const fetchUserData = async () => {
            try {
                setLoading(true);
                const currentUser = await UserService.getCurrentUser();
                const currentToken = await UserService.getCurrentToken();

                if (currentUser && currentToken) {
                    setUser(currentUser);
                    setToken(currentToken);
                    await fetchSubAccountantsData(currentUser.accountantId, currentToken, true, {
                        label: currentUser.name,
                        value: currentUser.accountantId,
                    });
                    // Only fetch available clients if user is not a client (latest value via ref — avoids effect re-runs)
                    if (userTypeContextRef.current?.toString() !== Constants.UserType.Client) {
                        await fetchAvailableClients(currentToken, currentUser.accountantId);
                    }
                } else {
                    navigate("/login");
                }
            } catch (error) {
                navigate("/login");
            }
            setLoading(false);
        };

        // Strict Mode mounts twice; component refs reset. Share one in-flight bootstrap so GetMinimalClients runs once.
        addClientBootstrapPromise ??= fetchUserData().finally(() => {
            addClientBootstrapPromise = null;
        });
        void addClientBootstrapPromise;
    }, [user, token, navigate]);

    const handleChange = (field, value) => {
        setFormData(prevState => {
            const fields = field.split('.');
            let newState = { ...prevState };
            let current = newState;

            for (let i = 0; i < fields.length - 1; i++) {
                current[fields[i]] = { ...current[fields[i]] };
                current = current[fields[i]];
            }

            current[fields[fields.length - 1]] = value;

            return newState;
        });
    };



    const handleCheckboxChange = (event) => {
        setFormData(prevFormData => ({
            ...prevFormData,
            useIncomeTaxAdvancePercentage: event.target.checked
        }));
    };

    const handlePCN874ReportingCheckboxChange = (event) => {
        setFormData(prevFormData => ({
            ...prevFormData,
            isRequiredToReportPCN874: event.target.checked
        }));
    };
    const [constantClientDescription, setConstantClientDescription] = useState('');
    const [constantInvoiceDescription, setConstantInvoiceDescription] = useState('');

    const fetchInvoiceConstantDetails = async (caseId, token) => {
        try {
            const response = await ClientService.GetConstantInvoiceDetailsByCaseId(caseId, token);
            if (response.ok) {
                const text = await response.text();
                if (!text || !String(text).trim()) return;
                const result = JSON.parse(text);
                setConstantClientDescription(result.constantClientDescription);
                setConstantInvoiceDescription(result.constantInvoiceDescription);
            }
        } catch (error) {
            console.error("Error fetching constant details:", error);
        }
    };

    const fieldErrors = {
        /* ——— required single-value fields ——— */
        ClientName: !formData.ClientName,
        CaseID: isEdit ? !formData.CaseID : !caseIdIsValid || (!isEdit && !isCaseIdValidForInitialPassword),
        ClientID: !formData.ClientID,
        ClientPhoneNumber: !formData.ClientPhoneNumber ||
            !validatePhoneNumber(formData.ClientPhoneNumber),
        ClientEmail: formData.ClientEmail && !validateEmail(formData.ClientEmail),

        CaseType: !formData.CaseType,
        ClientReportingType: !formData.ClientReportingType,
        advancedReportingType: !formData.advancedReportingType,
        AccountManagement: !formData.AccountManagement,

        /* ——— nested bank object ——— */
        bank: {
            bankCode: !formData.bank.bankCode,
            branchNumber: !formData.bank.branchNumber,
            accountNumber: !formData.bank.accountNumber,
        },

        /* ——— conditional income-tax fields ——— */
        incomeTaxAdvancePercentage: !formData.isPartners && formData.useIncomeTaxAdvancePercentage && !formData.incomeTaxAdvancePercentage,
        incomeTaxAdvanceAmount: !formData.isPartners && !formData.useIncomeTaxAdvancePercentage && !formData.incomeTaxAdvanceAmount,

        /* ——— optional / sanity checks ——— */
        officeIdentifyNumber: formData.officeIdentifyNumber !== null &&
            formData.officeIdentifyNumber !== '' &&
            isNaN(+formData.officeIdentifyNumber),

        withholdingTaxPercentage: formData.withholdingTaxPercentage !== '' &&
            (formData.withholdingTaxPercentage < 0 ||
                formData.withholdingTaxPercentage > 100),

        /* ——— case relationship validation ——— */
        relationshipType: formData.isSharedReporting && !formData.relationshipType,
        relatedCaseId: formData.isSharedReporting && !formData.relatedCaseId,
    };



    useEffect(() => {
        const doCheck = async () => {
            if (!user || !token) return;

            try {
                const caseId = isEdit ? client.caseId : "";   // empty while adding

                /* replace these two lines ↓↓↓ */
                // const res = await ClientService.checkLeadingExists(token, user.accountantId, caseId);
                // const data = await res.json();

                /* with this single line ↓↓↓ */
                const data = await ClientService.CheckIfLeadingBusinessExists(
                    token,
                    user.accountantId,
                );

                // data.leadingBusinessExists = “some other client is leading”

                setOtherLeadingExists(data.leadingBusinessExists);

                if (isEdit) {
                    setIsLeadingBusiness(!!client.leadingBusiness);
                }
            } catch (err) {
                console.error("Leading-business check failed", err);
            }
        };


        if (isEdit && client && token) {


            const fetchPackagePermission = async () => {
                try {

                    const [hasPremiumPackage, hasNoVatPerm, hasNoStatusPerm, hasManageOnlyPerm, hasTaxRefundPerm] = await Promise.all([
                        PermissionService.checkPermissionById(
                            client.caseId,
                            Constants.PermissionUserType.Client,
                            Constants.packageOptionsEnum.Premium,
                            token
                        ),
                        PermissionService.checkPermissionById(
                            client.caseId,
                            Constants.PermissionUserType.Client,
                            Constants.Permissions.CannotSeeVat,
                            token
                        ),
                        PermissionService.checkPermissionById(
                            client.caseId,
                            Constants.PermissionUserType.Client,
                            Constants.Permissions.CantSeeStatusDocuments,
                            token
                        ),
                        PermissionService.checkPermissionById(
                            client.caseId,
                            Constants.PermissionUserType.Client,
                            Constants.Permissions.ManageOnly,
                            token
                        ),
                        PermissionService.checkPermissionById(
                            client.caseId,
                            Constants.PermissionUserType.Client,
                            Constants.Permissions.TaxRefund,
                            token
                        )
                    ]);

                    // Remember the original ManageOnly state so we can allow downgrade only.
                    setOriginalManageOnly(!!hasManageOnlyPerm);
                    setOriginalTaxRefund(!!hasManageOnlyPerm && !!hasTaxRefundPerm);



                    const rawClientPaymentMethod = client.clientPaymentMethod ?? client.ClientPaymentMethod;
                    const normalizedClientPaymentMethod =
                        rawClientPaymentMethod === Constants.clientPaymentMethodOptionsEnum.Accountant ||
                        rawClientPaymentMethod === Constants.clientPaymentMethodOptionsEnum.Client
                            ? rawClientPaymentMethod
                            : Constants.clientPaymentMethodOptionsEnum.Accountant;

                    setServerOriginalClientPaymentMethod(normalizedClientPaymentMethod);

                    setFormData({
                        bank: {
                            bankCode: client.bank?.bankCode || '',
                            branchNumber: client.bank?.branchNumber || '',
                            accountNumber: client.bank?.accountNumber || '',
                            paymentMethod: client.bank?.paymentMethod || 0
                        },
                        CaseID: client.caseId || '',
                        ClientID: client.clientId || '',
                        taxClientNumber: client.taxClientNumber || '',
                        vatClientNumber: client.vatClientNumber || '',
                        deductionsCase: client.deductionsCase || '',
                        ClientName: client.name || '',
                        businessOwnerName: client.businessOwnerName || '',
                        spouseName: client.spouseName || '',
                        businessEstablishmentDate: client.businessEstablishmentDate
                            ? String(client.businessEstablishmentDate).slice(0, 10)
                            : '',
                        ClientPhoneNumber: formatIsraeliPhoneNumber(client.phoneNumber || ''),
                        ClientSecondaryPhoneNumber: formatIsraeliPhoneNumber(client.secondaryPhoneNumber || ''),
                        ClientNotes: client.notes || '',
                        ClientLocation: client.location || '',
                        ClientEmail: client.email || '',
                        ClientWebsite: client.website || '',
                        incomeTaxAdvancePercentage: client.incomeTaxAdvancePercentage || '',
                        useIncomeTaxAdvancePercentage: client.useIncomeTaxAdvancePercentage,
                        ClientReportingType: client.reportingType || '',
                        AccountManagement: client.accountManagement || '',
                        CaseType: client.caseType || '',
                        showVatPanelForTaxExempt: !!client.showVatPanelForTaxExempt,
                        subAccId: client.subAccountantId || '',
                        incomeTaxAdvanceAmount: client.incomeTaxAdvanceAmount || '',
                        taxAssessor: client.taxAssessor || '',
                        profilePicture: client.profilePicture || '',
                        signature: client.signature || '',
                        taxCreditPoints: client.taxCreditPoints || null,
                        clientPaymentMethod: normalizedClientPaymentMethod,
                        package: hasPremiumPackage ? Constants.packageOptionsEnum.Premium : Constants.packageOptionsEnum.Basic,
                        advancedReportingType: client.advancedReportingType,
                        officeIdentifyNumber: client.officeIdentifyNumber,
                        isRequiredToReportPCN874: client.isRequiredToReportPCN874,
                        withholdingTaxApprovalValidUntil: client.withholdingTaxApprovalValidUntil,
                        withholdingTaxPercentage: client.withholdingTaxPercentage,
                        leadingBusiness: !!client.leadingBusiness,
                        managesInventory: !!client.managesInventory,
                        managesProject: !!client.managesProject,
                        finsitePaidByClient: !!client.finsitePaidByClient,
                        isPartners: client.caseType === 'שותפות' || !!client.isPartners,
                        canSeeVat: !hasNoVatPerm,
                        canSeeDocumentStatus: !hasNoStatusPerm,
                        manageOnly: !!hasManageOnlyPerm,
                        taxRefund: !!hasManageOnlyPerm && !!hasTaxRefundPerm,
                        businessField: client.businessField,
                        businessType: client.businessType ?? client.BusinessType ?? -1,
                        economicBusinessBranch: (() => {
                            const raw = client.economicBusinessBranch ?? client.EconomicBusinessBranch;
                            if (raw === null || raw === undefined || raw === '') return '';
                            const asNum = Number(raw);
                            if (!Number.isNaN(asNum)) return asNum;
                            const matched = INDUSTRY_OPTIONS.find((o) => String(o.label).trim() === String(raw).trim());
                            return matched?.value ?? '';
                        })(),
                        // isSharedReporting, relationshipType, relatedCaseId are set by fetchCaseRelationships
                        // Don't override here — the async fetch is the source of truth
                    });

                    // Set client active status
                    setIsClientActive(client.isActive !== false); // Default to true if undefined

                } catch (error) {
                    console.error("Error checking package permission:", error);
                }
            };

            fetchPackagePermission();
            // fetchInvoiceConstantDetails(client.caseId, token);
            fetchCaseRelationships(client.caseId, token);
            doCheck();
        }
        doCheck();

    }, [isEdit, client, token]);


    useEffect(() => {
        if (isEdit && client) {

            setOfficePwd({
                isHave: !!client.isHaveOfficePassword,
                value: "",
                existsOnServer: !!client.isHaveOfficePassword,
            });
            // Legacy clients / missing flag → treat as changed (do not expose regenerated password).
            setHasChangedInitialPassword(client.hasChangedInitialPassword !== false);
        }
    }, [client, isEdit]);

    // Auto-set payer based on business field when editing
    useEffect(() => {
        if (isEdit && client && formData.businessField !== undefined) {
            if (formData.businessField === Constants.VehicleDealership || formData.businessField === Constants.Garage) {
                handleChange('clientPaymentMethod', 1); // Client (Business)
            }
        }
    }, [formData.businessField, isEdit, client]);
    useEffect(() => {
        if (i18n.language === 'he' || i18n.language === 'ar') {
            setDirection('rtl');
        } else {
            setDirection('ltr');
        }
    }, [i18n.language]);

    // Auto-set isPartners based on CaseType
    useEffect(() => {
        if (formData.CaseType === 'שותפות') {
            if (!formData.isPartners) {
                handleChange('isPartners', true);
            }
        } else {
            if (formData.isPartners) {
                handleChange('isPartners', false);
            }
        }
    }, [formData.CaseType]);


    // Example options for Select components
    const formattedCaseTypeOptions = Constants.CaseTypeOptions?.map(option => ({
        value: option.name,
        label: `${option.name}`,
        name: option.name,
    }));

    // Get VAT exempt case type from constants
    const vatExemptCaseType = Constants.CaseTypeOptions?.find(option => option.value === 'עוסק פטור')?.value;

    const formattedSubAccOptions = subAccountants?.map(option => ({
        value: option.value,
        label: `${option.label}`,
        name: option.label,
    }));

    const formattedAccountManagementOptions = Constants.AccountManagementOptions?.map(option => ({
        value: option.name,
        label: `${option.name}`,
        name: option.name,
    }));

    const formattedReportingTypeOptions = Constants.ReportingTypeOptions?.map(option => ({
        value: option.name,
        label: `${option.name}`,
        name: option.name,
    }));
    const formattedBusinessTypeOptions = [
        { value: -1, label: t('BusinessType_NotSet') || 'לא הוגדר' },
        { value: 1, label: t('BusinessType_Industrial') || 'תעשייתי' },
        { value: 2, label: t('BusinessType_Commercial') || 'מסחרי' },
        { value: 3, label: t('BusinessType_ServiceProviders') || 'נותני שירותים' },
        { value: 4, label: t('BusinessType_MultipleBusinesses') || 'הדוח כולל יותר מעסק אחד' }
    ];

    const formattedPaymentMethodOptions = Constants.PaymentMethod.map(option => ({
        value: option.value,
        label: t(option.name),
        name: option.name,
    }));

    const formattedBusinessFieldOptions = Constants.BusinessFieldOptions?.map(option => ({
        value: option.value,
        label: t(option.name),
        name: option.name,
    }));

    const formattedIndustryOptions = INDUSTRY_OPTIONS?.map(option => ({
        value: option.value,
        label: option.label,
        name: option.label,
    }));

    const addClientFontFamily = "'Heebo', sans-serif";
    const addClientSelectFont = 'var(--xtram-panel-section, 15px)';
    const addClientSelectHeight = 'var(--xtram-client-data-head-height, 38px)';

    const customSelectStyles = (hasError = false) => ({
        control: (provided) => ({
            ...provided,
            fontFamily: addClientFontFamily,
            fontSize: addClientSelectFont,
            minHeight: addClientSelectHeight,
            borderRadius: '8px',
            background: '#F5F5F6',
            boxShadow: 'none',
            padding: '0 10px',
            textAlign: 'left',
            boxSizing: 'border-box',
            '&:focus-within': {
                border: '2px solid var(--Foundation-Blue-Normal, #304FFF)',
            },
            border: hasError ? '2px solid #d32f2f' : '1px solid transparent',
        }),
        valueContainer: (provided) => ({
            ...provided,
            fontSize: addClientSelectFont,
        }),
        placeholder: (provided) => ({
            ...provided,
            fontFamily: addClientFontFamily,
            fontSize: addClientSelectFont,
            textAlign: 'left',
        }),
        singleValue: (provided) => ({
            ...provided,
            fontFamily: addClientFontFamily,
            fontSize: addClientSelectFont,
            textAlign: 'left',
            color: 'black',
        }),
        input: (provided) => ({
            ...provided,
            fontFamily: addClientFontFamily,
            fontSize: addClientSelectFont,
        }),
        menu: (provided) => ({
            ...provided,
            fontFamily: addClientFontFamily,
            fontSize: addClientSelectFont,
            textAlign: 'left',
            color: 'black',
        }),
        menuList: (provided) => ({
            ...provided,
            fontSize: addClientSelectFont,
        }),
        option: (provided, state) => ({
            ...provided,
            fontFamily: addClientFontFamily,
            fontSize: addClientSelectFont,
            backgroundColor: state.isSelected
                ? '#F9AA2A' // Selected color remains the same
                : state.isFocused
                    ? '#f0eded' // New hover color (gold)
                    : null,
            color: 'black',
        }),
    });





    const syncClientPackagePermissions = async (caseId) => {
        const isStaffUser =
            userTypeContext?.toString() === Constants.UserType.Accountant ||
            userTypeContext?.toString() === Constants.UserType.SubAccountant;

        if (!isStaffUser) {
            return true;
        }

        let allOk = true;
        const runPermissionCall = async (promise) => {
            const result = await promise;
            if (result === false) {
                allOk = false;
            }
        };

        if (formData.package === Constants.packageOptionsEnum.Premium) {
            await runPermissionCall(
                PermissionService.assignPermission(caseId, Constants.PermissionUserType.Client, Constants.packageOptionsEnum.Premium, token)
            );
        } else if (formData.package === Constants.packageOptionsEnum.Basic) {
            await runPermissionCall(
                PermissionService.removePermission(caseId, Constants.PermissionUserType.Client, Constants.packageOptionsEnum.Premium, token)
            );
        }

        if (originalManageOnly && !formData.manageOnly) {
            await runPermissionCall(
                PermissionService.removePermission(
                    caseId,
                    Constants.PermissionUserType.Client,
                    Constants.Permissions.ManageOnly,
                    token
                )
            );
        } else if (!isEdit && formData.manageOnly) {
            await runPermissionCall(
                PermissionService.assignPermission(
                    caseId,
                    Constants.PermissionUserType.Client,
                    Constants.Permissions.ManageOnly,
                    token
                )
            );
        } else if (!isEdit && !formData.manageOnly) {
            await runPermissionCall(
                PermissionService.removePermission(
                    caseId,
                    Constants.PermissionUserType.Client,
                    Constants.Permissions.ManageOnly,
                    token
                )
            );
        }

        const wantsTaxRefund = formData.manageOnly && formData.taxRefund;
        if (wantsTaxRefund && !isEdit) {
            await runPermissionCall(
                PermissionService.assignPermission(
                    caseId,
                    Constants.PermissionUserType.Client,
                    Constants.Permissions.TaxRefund,
                    token
                )
            );
        } else if (!wantsTaxRefund && (!isEdit || originalTaxRefund)) {
            await runPermissionCall(
                PermissionService.removePermission(
                    caseId,
                    Constants.PermissionUserType.Client,
                    Constants.Permissions.TaxRefund,
                    token
                )
            );
        }

        return allOk;
    };

    const syncClientVisibilityPermissions = async (caseId) => {
        const isStaffUser =
            userTypeContext?.toString() === Constants.UserType.Accountant ||
            userTypeContext?.toString() === Constants.UserType.SubAccountant;

        if (!isStaffUser) {
            return true;
        }

        let allOk = true;
        const runPermissionCall = async (promise) => {
            const result = await promise;
            if (result === false) {
                allOk = false;
            }
        };

        if (!formData.canSeeVat) {
            await runPermissionCall(
                PermissionService.assignPermission(
                    caseId,
                    Constants.PermissionUserType.Client,
                    Constants.Permissions.CannotSeeVat,
                    token
                )
            );
        } else {
            await runPermissionCall(
                PermissionService.removePermission(
                    caseId,
                    Constants.PermissionUserType.Client,
                    Constants.Permissions.CannotSeeVat,
                    token
                )
            );
        }

        if (!formData.canSeeDocumentStatus) {
            await runPermissionCall(
                PermissionService.assignPermission(
                    caseId,
                    Constants.PermissionUserType.Client,
                    Constants.Permissions.CantSeeStatusDocuments,
                    token
                )
            );
        } else {
            await runPermissionCall(
                PermissionService.removePermission(
                    caseId,
                    Constants.PermissionUserType.Client,
                    Constants.Permissions.CantSeeStatusDocuments,
                    token
                )
            );
        }

        return allOk;
    };

    const closeInitialPasswordModal = () => {
        setInitialPasswordModalOpen(false);
        setInitialPasswordValue('');
        const shouldNavigate = pendingNavigateAfterPasswordRef.current;
        pendingNavigateAfterPasswordRef.current = false;
        setInitialPasswordModalAfterCreate(false);
        if (shouldNavigate) {
            navigate('/main', { state: { refreshCache: true } });
        }
    };

    const openShowInitialPassword = async () => {
        // Client + accountant + sub-accountant may view while the initial password is still active.
        if (!token || !formData.CaseID || hasChangedInitialPassword) return;
        if (!(isClient || isAccountant || isSubAccountant)) return;
        try {
            const res = await ClientService.GetInitialPassword(token, formData.CaseID);
            if (!res.ok) {
                if (res.status === 403) {
                    setHasChangedInitialPassword(true);
                    toast.info(t('PasswordChangedByClient'));
                } else {
                    toast.error(t('FailedToLoadInitialPassword'));
                }
                return;
            }
            const data = await res.json();
            const password = data?.initialPassword || data?.InitialPassword;
            if (!password) {
                toast.error(t('FailedToLoadInitialPassword'));
                return;
            }
            setInitialPasswordValue(password);
            setInitialPasswordModalAfterCreate(false);
            setInitialPasswordModalOpen(true);
        } catch (err) {
            console.error(err);
            toast.error(t('FailedToLoadInitialPassword'));
        }
    };

    const handleClientSave = async (dontCheckPayer = false) => {
        if (!allFieldsFilled && !isEdit) {
            if (!isEdit && formData.CaseID && !isCaseIdValidForInitialPassword) {
                toast.error(t('CaseIdMustBe9Or10Digits'));
            } else {
                toast.info(t('ErrorRequiredFields'));
            }
        } else {

            if (!dontCheckPayer && payerSwitched) {
                logPayerCard('handleClientSave: opening SwitchPayerModal (payerSwitched)', {
                    dontCheckPayer,
                    payerSwitched,
                    caseId: formData.CaseID,
                    baselineClientPaymentMethod,
                    nextClientPaymentMethod: formData.clientPaymentMethod
                });
                // Always go through switch-to-business (with or without card); modal calls API then onSuccess continues save
                setShowSwitchModal(true);
                setLoading(false);
                return;
            }
            setLoading(true);
            try {
                const officeIdentifyNumber =
                    formData?.officeIdentifyNumber
                        ? String(formData.officeIdentifyNumber).trim()
                        : null;
                const defaultReportingType = Constants.ReportingTypeOptions?.[0]?.name;
                const withLimitedDefault = (value, fallback) => value || (isLimitedClient ? fallback : value);
                const clientData = {
                    caseId: formData.CaseID,
                    AccountantId: user.accountantId,
                    accountantId: user.accountantId,
                    clientId: formData.ClientID,
                    // On edit an empty string clears the value; null would leave it unchanged.
                    taxClientNumber: isEdit ? (formData.taxClientNumber?.trim() ?? '') : (formData.taxClientNumber?.trim() || null),
                    vatClientNumber: isEdit ? (formData.vatClientNumber?.trim() ?? '') : (formData.vatClientNumber?.trim() || null),
                    name: formData.ClientName,
                    businessOwnerName: formData.businessOwnerName?.trim() || null,
                    spouseName: isEdit ? (formData.spouseName?.trim() ?? '') : (formData.spouseName?.trim() || null),
                    businessEstablishmentDate: formData.businessEstablishmentDate || null,
                    clearBusinessEstablishmentDate: isEdit && !formData.businessEstablishmentDate,
                    // Password is generated server-side from CaseId on create; never sent from the UI.
                    phoneNumber: normalizeIsraeliPhoneNumberForStorage(formData.ClientPhoneNumber),
                    secondaryPhoneNumber: formData.ClientSecondaryPhoneNumber?.trim()
                        ? normalizeIsraeliPhoneNumberForStorage(formData.ClientSecondaryPhoneNumber.trim())
                        : null,
                    notes: formData.ClientNotes || null,
                    caseType: formData.CaseType,
                    showVatPanelForTaxExempt: Constants.TaxExemptTypes.includes(formData.CaseType)
                        ? !!formData.showVatPanelForTaxExempt
                        : false,
                    AccountManagement: withLimitedDefault(formData.AccountManagement, Constants.AccountManagementOptions?.[0]?.name),
                    SubAccountantId: formData.subAccId,
                    IncomeTaxAdvancePercentage: parseFloat(formData.incomeTaxAdvancePercentage),
                    IncomeTaxAdvanceAmount: parseFloat(formData.incomeTaxAdvanceAmount),
                    UseIncomeTaxAdvancePercentage: formData.useIncomeTaxAdvancePercentage,
                    Website: formData.ClientWebsite,
                    Location: formData.ClientLocation?.trim() || null,
                    Email: formData.ClientEmail,
                    ReportingType: withLimitedDefault(formData.ClientReportingType, defaultReportingType),
                    Bank: {
                        bankCode: formData.bank.bankCode,
                        branchNumber: formData.bank.branchNumber,
                        accountNumber: formData.bank.accountNumber,
                        paymentMethod: formData.bank.paymentMethod
                    },
                    deductionsCase: formData.deductionsCase,
                    taxAssessor: formData.taxAssessor?.toString(),
                    taxCreditPoints: formData.taxCreditPoints || 0,
                    // When creating a new client, payer must start as Accountant.
                    clientPaymentMethod: isEdit
                        ? formData.clientPaymentMethod
                        : Constants.clientPaymentMethodOptionsEnum.Accountant,
                    advancedReportingType: withLimitedDefault(formData.advancedReportingType, defaultReportingType),
                    officeIdentifyNumber: officeIdentifyNumber,
                    isRequiredToReportPCN874: formData.isRequiredToReportPCN874,
                    withholdingTaxApprovalValidUntil: formData.withholdingTaxApprovalValidUntil,
                    withholdingTaxPercentage: formData.withholdingTaxPercentage,
                    leadingBusiness: formData.leadingBusiness,
                    managesInventory: formData.managesInventory,
                    managesProject: formData.managesProject,
                    // Kept as chosen even while the accountant is the payer, so flipping the payer back and
                    // forth does not lose the setting; billing ignores it in months the accountant pays.
                    finsitePaidByClient: !!formData.finsitePaidByClient,
                    isPartners: formData.isPartners,
                    isHaveOfficePassword: officePwd.isHave,
                    businessField: formData.businessField,
                    businessType: Number(formData.businessType),
                    economicBusinessBranch: formData.economicBusinessBranch !== '' && formData.economicBusinessBranch != null
                        ? String(formData.economicBusinessBranch)
                        : null,
                    isSharedReporting: formData.isSharedReporting,
                    relationshipType: formData.relationshipType,
                    relatedCaseId: formData.relatedCaseId,
                    sendWelcomeEmail: !!formData.sendWelcomeEmail,
                    sendWelcomeWhatsApp: !!formData.sendWelcomeWhatsApp,
                    sendDocumentsInfoEmail: !!formData.sendDocumentsInfoEmail,
                    sendDocumentsInfoWhatsApp: !!formData.sendDocumentsInfoWhatsApp,
                    // Edit-only: optional plaintext for re-sending welcome notifications (does not change login).
                    welcomePassword: isEdit
                        ? (formData.welcomePasswordForNotification?.trim() || null)
                        : null,

                };

                if (isEdit && (formData.sendWelcomeEmail || formData.sendWelcomeWhatsApp) && !clientData.welcomePassword) {
                    toast.error(t('WelcomePasswordRequired'));
                    setLoading(false);
                    return;
                }

                if (isEdit) {
                    // When switching payer to Accountant: ensure no unpaid balance (pay via ClientBlockerWindow if needed)
                    if (switchingToAccountant && user?.accountantId) {
                        try {
                            const result = await PaymentService.accountant.previewUnpaidMonths(formData.CaseID);
                            const amount = result?.amount ?? result?.data?.totals?.netBalance ?? 0;
                            if (Number(amount) > 0) {
                                pendingClientDataRef.current = clientData;
                                setShowClientBlockerForEdit(true);
                                setLoading(false);
                                return;
                            }
                        } catch (_) {
                            // Proceed with save if preview fails (backend will validate)
                        }
                    }

                    // Update existing client
                    try {
                        const response = await ClientService.UpdateClient(token, clientData);
                        if (response?.ok) {
                            // Handle case relationships
                            await handleCaseRelationships(token, clientData.caseId, isEdit);

                            const packagePermissionsOk = await syncClientPackagePermissions(clientData.caseId);
                            const visibilityPermissionsOk = await syncClientVisibilityPermissions(clientData.caseId);

                            // Fetch the updated client data
                            const updatedClient = await ClientService.GetClient(token, clientData.caseId);

                            // ✅ Clear cache so Main page will show updated client data
                            invalidateMainPageCache(clientData.accountantId);

                            if (packagePermissionsOk && visibilityPermissionsOk) {
                                toast.success(t('CustomerUpdatedSuccessfully'));
                            } else {
                                toast.warn(t('CustomerUpdatedButPermissionsFailed') || 'Client updated but some permission changes could not be saved.');
                            }

                            // Navigate to '/client-details' with the updated client data
                            navigate('/client-details', { state: { client: updatedClient } });
                        } else {
                            toast.error(t('FailedToUpdateCustomer'));
                        }
                    } catch (err) {
                        if (err?.body?.hasUnpaidBalance) {
                            pendingClientDataRef.current = clientData;
                            setShowClientBlockerForEdit(true);
                            setLoading(false);
                            return;
                        }
                        toast.error(err?.body?.message || t('FailedToUpdateCustomer'));
                        throw err;
                    }

                } else {
                    // Add new client — password is generated and hashed on the server from CaseId.
                    const response = await UserService.addClient(clientData, token);

                    if (response.ok) {
                        let createdInitialPassword = null;
                        try {
                            const body = await response.json();
                            createdInitialPassword = body?.initialPassword || body?.InitialPassword || null;
                        } catch (_) {
                            // Older/unexpected payload — still proceed without modal password.
                        }

                        // Handle case relationships for new client
                        await handleCaseRelationships(token, clientData.caseId, false);

                        const packagePermissionsOk = await syncClientPackagePermissions(clientData.caseId);
                        const visibilityPermissionsOk = await syncClientVisibilityPermissions(clientData.caseId);

                        // ✅ Clear cache so Main page will refetch and show the new client
                        invalidateMainPageCache(clientData.accountantId);

                        if (packagePermissionsOk && visibilityPermissionsOk) {
                            toast.success(t('CustomerAddedSuccessfully'));
                        } else {
                            toast.warn(t('CustomerAddedButPermissionsFailed') || 'Client added but some permission changes could not be saved.');
                        }

                        if (createdInitialPassword) {
                            setInitialPasswordValue(createdInitialPassword);
                            setInitialPasswordModalAfterCreate(true);
                            pendingNavigateAfterPasswordRef.current = true;
                            setInitialPasswordModalOpen(true);
                        } else {
                            navigate('/main', { state: { refreshCache: true } });
                        }
                    } else {
                        toast.error(t('FailedToAddCustomer'));
                    }
                }
            } catch (error) {
                console.error(error);
                toast.error(t('FailedToSaveCustomer'));
            }
            setLoading(false);
        }
    };


    const handleGoBack = () => {
        // navigate(-1);
        goBack();
    };

    const handleDeleteClick = async (caseId) => {
        // First step: Warning confirmation
        const firstStep = await Swal.fire({
            title: t('DeleteClient') || 'Delete Client',
            text: t('AreYouSureDeleteClient') || 'Are you sure you want to delete this client? This action cannot be undone.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DC3545',
            cancelButtonColor: '#6c757d',
            confirmButtonText: t('Continue') || 'Continue',
            cancelButtonText: t('Cancel') || 'Cancel',
            reverseButtons: true
        });

        if (!firstStep.isConfirmed) {
            return;
        }

        // Show DeleteUserDialog after Swal confirmation
        setItemIdToDelete(caseId);
        setOpenDeleteDialog(true);
    };

    const handleCloseDeleteDialog = () => {
        setOpenDeleteDialog(false);
        setItemIdToDelete(null);
    };

    const handleDeletePermanently = async () => {
        console.log('handleDeletePermanently called', { itemIdToDelete, token });

        if (!itemIdToDelete || !token) {
            console.log('Early return: missing itemIdToDelete or token');
            return;
        }

        setLoading(true);
        setOpenDeleteDialog(false);

        try {
            console.log('Attempting to delete client:', itemIdToDelete);
            const response = await ClientService.DeleteClient(token, itemIdToDelete);
            console.log('Delete response:', response);

            if (response.ok) {
                await Swal.fire({
                    title: t('Deleted') || 'Deleted!',
                    text: t('deleteClientSuccess') || 'Client has been deleted successfully.',
                    icon: 'success',
                    confirmButtonColor: '#304FFF'
                });
                // Clear cache and navigate to main page
                invalidateMainPageCache(user.accountantId);
                navigate('/main', { state: { refreshCache: true } });
            } else {
                const errorResponse = await response.json();
                console.error('Error deleting client:', errorResponse);
                await Swal.fire({
                    title: t('Error') || 'Error',
                    text: t('deleteClientFailure') || 'Failed to delete client. Please try again.',
                    icon: 'error',
                    confirmButtonColor: '#DC3545'
                });
            }
        } catch (error) {
            console.error('Error deleting client:', error);
            await Swal.fire({
                title: t('Error') || 'Error',
                text: t('errorDeletingClient') || 'An error occurred while deleting the client.',
                icon: 'error',
                confirmButtonColor: '#DC3545'
            });
        }

        setItemIdToDelete(null);
        setLoading(false);
    };

    const handleInactiveUser = async () => {
        if (!formData.CaseID || !token) {
            toast.error(t('Error') || 'Missing required information');
            return;
        }

        // Confirmation dialog
        const confirmResult = await Swal.fire({
            title: t('DisableClient') || 'Disable Client',
            text: t('AreYouSureDisableClient') || 'Are you sure you want to disable this client? The client will not be able to log in.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#FF9800',
            cancelButtonColor: '#6c757d',
            confirmButtonText: t('Disable') || 'Disable',
            cancelButtonText: t('Cancel') || 'Cancel',
            reverseButtons: true
        });

        if (!confirmResult.isConfirmed) {
            return;
        }

        setLoading(true);
        setOpenDeleteDialog(false);
        setItemIdToDelete(null);

        try {
            // Disable the client
            const response = await AuthService.EnableDisable(
                formData.CaseID,
                Constants.UserTypeInt.Client,
                false, // isActive = false
                token
            );

            if (response?.message || response?.data) {
                setIsClientActive(false);
                await Swal.fire({
                    title: t('Disabled') || 'Disabled!',
                    text: t('ClientDisabledSuccessfully') || 'Client has been disabled successfully.',
                    icon: 'success',
                    confirmButtonColor: '#304FFF'
                });

                // Clear cache and refresh
                invalidateMainPageCache(user.accountantId);
            } else {
                await Swal.fire({
                    title: t('Error') || 'Error',
                    text: t('FailedToDisableClient') || 'Failed to disable client. Please try again.',
                    icon: 'error',
                    confirmButtonColor: '#DC3545'
                });
            }
        } catch (error) {
            console.error('Error disabling client:', error);
            await Swal.fire({
                title: t('Error') || 'Error',
                text: t('ErrorDisablingClient') || 'An error occurred while disabling the client.',
                icon: 'error',
                confirmButtonColor: '#DC3545'
            });
        } finally {
            setLoading(false);
        }
    };

    const handleEnableUser = async () => {
        if (!formData.CaseID || !token) {
            toast.error(t('Error') || 'Missing required information');
            return;
        }

        // Confirmation dialog
        const confirmResult = await Swal.fire({
            title: t('EnableClient') || 'Enable Client',
            text: t('AreYouSureEnableClient') || 'Are you sure you want to enable this client?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#28a745',
            cancelButtonColor: '#6c757d',
            confirmButtonText: t('Enable') || 'Enable',
            cancelButtonText: t('Cancel') || 'Cancel',
            reverseButtons: true
        });

        if (!confirmResult.isConfirmed) {
            return;
        }

        setLoading(true);

        try {
            // Enable the client
            const response = await AuthService.EnableDisable(
                formData.CaseID,
                Constants.UserTypeInt.Client,
                true, // isActive = true
                token
            );

            if (response?.message || response?.data) {
                setIsClientActive(true);
                await Swal.fire({
                    title: t('Enabled') || 'Enabled!',
                    text: t('ClientEnabledSuccessfully') || 'Client has been enabled successfully.',
                    icon: 'success',
                    confirmButtonColor: '#304FFF'
                });

                // Clear cache and refresh
                invalidateMainPageCache(user.accountantId);
            } else {
                await Swal.fire({
                    title: t('Error') || 'Error',
                    text: t('FailedToEnableClient') || 'Failed to enable client. Please try again.',
                    icon: 'error',
                    confirmButtonColor: '#DC3545'
                });
            }
        } catch (error) {
            console.error('Error enabling client:', error);
            await Swal.fire({
                title: t('Error') || 'Error',
                text: t('ErrorEnablingClient') || 'An error occurred while enabling the client.',
                icon: 'error',
                confirmButtonColor: '#DC3545'
            });
        } finally {
            setLoading(false);
        }
    };




    // userTypeContext?.toString() === Constants.UserType.Accountant

    const isAccountant = userTypeContext?.toString() === Constants.UserType.Accountant;
    const isSubAccountant = userTypeContext?.toString() === Constants.UserType.SubAccountant;
    const isClient = userTypeContext?.toString() === Constants.UserType.Client;

    const [pwdDialogOpen, setPwdDialogOpen] = useState(false);
    const [pwdValue, setPwdValue] = useState("");
    const [pwdError, setPwdError] = useState("");

    // Reset client login password (Accountant only)
    const [resetPwdDialogOpen, setResetPwdDialogOpen] = useState(false);
    const [resetPwdValue, setResetPwdValue] = useState("");
    const [resetPwdError, setResetPwdError] = useState("");
    const [oldResetPwdValue, setOldResetPwdValue] = useState("");
    const [oldResetPwdError, setOldResetPwdError] = useState("");

    const showPackageSettings = (isAccountant || isSubAccountant) && userTypeContext?.toString() !== Constants.UserType.Client && userTypeContext?.toString() !== permissionsState.Premium
    const showClientBusinessSettings = (isAccountant || isSubAccountant) && userTypeContext?.toString() !== Constants.UserType.Client && userTypeContext?.toString() !== permissionsState.Premium

    /*  Call this after a successful client save/update  */
    const saveOfficePassword = async () => {

        if (!officePwd.isHave) return; // checkbox off → nothing to do

        try {
            let response;

            if (officePwd.existsOnServer) {
                // change/reset
                response = await ClientService.resetOfficePassword(
                    token,
                    formData.CaseID,
                    officePwd.value
                );
            } else {
                // first-time set
                response = await ClientService.setOfficePassword(
                    token,
                    formData.CaseID,
                    officePwd.value
                );
            }

            if (!response.ok) {
                // Server returned an error code
                const errorBody = await response.text();
                console.error("Office-password error:", errorBody);
                throw new Error(`Status ${response.status}`);
            }

            // Parse the JSON response if needed
            const result = await response.json();

            // ✅ Update local state if it was set for the first time
            if (!officePwd.existsOnServer) {
                setOfficePwd((p) => ({ ...p, existsOnServer: true }));
            }

            toast.success(
                t(officePwd.existsOnServer ? "OfficePasswordChanged" : "OfficePasswordSet")
            );
        } catch (err) {
            console.error("Failed to save office password:", err);
            toast.error(t("FailedToSaveOfficePassword"));
        }
    };


    return (
        <>
            <ProfileSignatureDialog
                open={openSignatureDialog}
                onClose={() => setOpenSignatureDialog(false)}
                onSave={(data) => {

                }}
                existingSignature={formData?.signature}         // if available
                existingProfilePicture={formData?.profilePicture}   // if available
                token={token}
                accountantId={user?.accountantId}
                caseId={formData?.CaseID}
            />

            <>
                <>
                    {/* <div className={`main-title ${direction}`}>{isEdit ? t('EditClient') : t('addClientTitle')}</div> */}
                    <div className={`${Styles['add-client-form']} ${direction}`} >


                        <div className={Styles['add-client-form-three-columns-layout']}>
                            <div className={Styles['add-client-section-container']}>
                                <div className={`main-title2 ${direction} ${Styles['section-header-row']}`}>
                                    <span className={Styles['section-title-text']}>{t('BusinessData')}</span>
                                    {isEdit && (!permissionsState.ViewSubAccountantClients && userTypeContext?.toString() !== Constants.UserType.Client) && (
                                        <div className={Styles['section-header-actions']}>
                                            {isClientActive ? (
                                                <Button
                                                    onClick={() => handleDeleteClick(formData.CaseID)}
                                                    sx={{
                                                        color: '#DC3545',
                                                        borderColor: '#DC3545',
                                                        padding: '6px 12px',
                                                        fontSize: 'var(--xtram-text-sm, 14px)',
                                                        fontWeight: '600',
                                                        textTransform: 'none',
                                                        borderRadius: '8px',
                                                        minWidth: 'auto',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '6px',
                                                        '&:hover': {
                                                            backgroundColor: 'rgba(220, 53, 69, 0.1)',
                                                            borderColor: '#DC3545',
                                                        }
                                                    }}
                                                    variant="outlined"
                                                >
                                                    <img src={deleteIcon} alt="" style={{ width: 'var(--xtram-panel-icon-sm, 16px)', height: 'var(--xtram-panel-icon-sm, 16px)' }} />
                                                    {t('DeleteClient')}
                                                </Button>
                                            ) : null}
                                            {isClientActive ? (
                                                <Button
                                                    onClick={handleInactiveUser}
                                                    disabled={loading}
                                                    sx={{
                                                        color: '#FF9800',
                                                        borderColor: '#FF9800',
                                                        padding: '6px 12px',
                                                        fontSize: 'var(--xtram-text-sm, 14px)',
                                                        fontWeight: '600',
                                                        textTransform: 'none',
                                                        borderRadius: '8px',
                                                        minWidth: 'auto',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '6px',
                                                        '&:hover': {
                                                            backgroundColor: 'rgba(255, 152, 0, 0.1)',
                                                            borderColor: '#FF9800',
                                                        },
                                                        '&:disabled': {
                                                            color: '#ccc',
                                                            borderColor: '#ccc',
                                                        }
                                                    }}
                                                    variant="outlined"
                                                >
                                                    {t('DisableClient')}
                                                </Button>
                                            ) : (
                                                <Button
                                                    onClick={handleEnableUser}
                                                    disabled={loading}
                                                    sx={{
                                                        color: '#28a745',
                                                        borderColor: '#28a745',
                                                        padding: '6px 12px',
                                                        fontSize: 'var(--xtram-text-sm, 14px)',
                                                        fontWeight: '600',
                                                        textTransform: 'none',
                                                        borderRadius: '8px',
                                                        minWidth: 'auto',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '6px',
                                                        '&:hover': {
                                                            backgroundColor: 'rgba(40, 167, 69, 0.1)',
                                                            borderColor: '#28a745',
                                                        },
                                                        '&:disabled': {
                                                            color: '#ccc',
                                                            borderColor: '#ccc',
                                                        }
                                                    }}
                                                    variant="outlined"
                                                >
                                                    {t('EnableClient')}
                                                </Button>
                                            )}
                                            {!isClientActive && (
                                                <Button
                                                    onClick={() => handleDeleteClick(formData.CaseID)}
                                                    sx={{
                                                        color: '#DC3545',
                                                        borderColor: '#DC3545',
                                                        padding: '6px 12px',
                                                        fontSize: 'var(--xtram-text-sm, 14px)',
                                                        fontWeight: '600',
                                                        textTransform: 'none',
                                                        borderRadius: '8px',
                                                        minWidth: 'auto',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '6px',
                                                        '&:hover': {
                                                            backgroundColor: 'rgba(220, 53, 69, 0.1)',
                                                            borderColor: '#DC3545',
                                                        }
                                                    }}
                                                    variant="outlined"
                                                >
                                                    <img src={deleteIcon} alt="" style={{ width: 'var(--xtram-panel-icon-sm, 16px)', height: 'var(--xtram-panel-icon-sm, 16px)' }} />
                                                    {t('DeleteClient')}
                                                </Button>
                                            )}
                                        </div>
                                    )}
                                </div>
                                <div className={Styles['add-client-section-container-fields']}>
                                    <div className={Styles['form-row-item-3']}>
                                        <div className={Styles['form-row-item-title3']}>
                                            {t('enterName')}<span className="required-asterisk">*</span>
                                        </div>
                                        <TextField
                                            fullWidth
                                            placeholder={t('enterName')}
                                            value={formData.ClientName}
                                            onChange={(e) => handleChange('ClientName', e.target.value)}
                                            className={Styles['add-client-input-style']}
                                            variant="standard"
                                            InputProps={styledInput(direction, fieldErrors.ClientName)}
                                            inputProps={{
                                                style: {
                                                    textAlign: direction === 'ltr' ? 'left' : 'right',
                                                },
                                            }}
                                            required
                                        />
                                    </div>

                                    <div className={Styles['form-row-item-3']}>
                                        <div className={Styles['form-row-item-title3']}>
                                            {t('businessOwnerName')}
                                        </div>
                                        <TextField
                                            fullWidth
                                            placeholder={t('businessOwnerName')}
                                            value={formData.businessOwnerName}
                                            onChange={(e) => handleChange('businessOwnerName', e.target.value)}
                                            className={Styles['add-client-input-style']}
                                            variant="standard"
                                            InputProps={styledInput(direction)}
                                            inputProps={{
                                                style: {
                                                    textAlign: direction === 'ltr' ? 'left' : 'right',
                                                },
                                            }}
                                        />
                                    </div>

                                    {!isLimitedClient && (
                                    <div className={Styles['form-row-item-3']}>
                                        <div className={Styles['form-row-item-title3']}>
                                            {t('SpouseName')}
                                        </div>
                                        <TextField
                                            fullWidth
                                            placeholder={t('SpouseName')}
                                            value={formData.spouseName}
                                            onChange={(e) => handleChange('spouseName', e.target.value)}
                                            className={Styles['add-client-input-style']}
                                            variant="standard"
                                            InputProps={styledInput(direction)}
                                            inputProps={{
                                                style: {
                                                    textAlign: direction === 'ltr' ? 'left' : 'right',
                                                },
                                            }}
                                        />
                                    </div>
                                    )}


                                    <div className={Styles['form-row-item-3']}>
                                        <div className={Styles['form-row-item-title3']}>
                                            {formData.CaseType === vatExemptCaseType ? t('VatExemptId') : t('CompanyId')}<span className="required-asterisk">*</span>
                                        </div>
                                        <TextField
                                            fullWidth
                                            placeholder={formData.CaseType === vatExemptCaseType ? t('VatExemptId') : t('CompanyId')}
                                            value={formData.CaseID}
                                            onChange={(e) => handleChange('CaseID', e.target.value.replace(/\D/g, '').slice(0, 10))}
                                            className={Styles['add-client-input-style']}
                                            variant="standard"
                                            required
                                            disabled={isEdit}
                                            error={!isEdit && !!formData.CaseID && !caseIdIsValid}
                                            helperText={!isEdit && formData.CaseID && !caseIdIsValid ? t('CaseIdDigitsRange') : ''}
                                            FormHelperTextProps={{ sx: { color: '#d32f2f', mx: 0 } }}
                                            InputProps={styledInput(direction, fieldErrors.CaseID)}
                                            inputProps={{
                                                inputMode: 'numeric',
                                                maxLength: 10,
                                                pattern: '[0-9]*',
                                                style: {
                                                    textAlign: direction === 'ltr' ? 'left' : 'right',
                                                },
                                            }}
                                        />
                                    </div>

                                    <div className={Styles['form-row-item-3']}>
                                        <div className={Styles['form-row-item-title3']}>
                                            {t('enterClientID')}<span className="required-asterisk">*</span>
                                        </div>
                                        <TextField
                                            fullWidth
                                            type="number"
                                            placeholder={t('enterClientID')}
                                            value={formData.ClientID}
                                            onChange={(e) => handleChange('ClientID', e.target.value)}
                                            className={Styles['add-client-input-style']}
                                            variant="standard"
                                            InputProps={styledInput(direction, fieldErrors.ClientID)}
                                            inputProps={{
                                                style: {
                                                    textAlign: direction === 'ltr' ? 'left' : 'right',
                                                },
                                            }}
                                            required
                                        />
                                    </div>

                                    {!isLimitedClient && (
                                    <>
                                    <div className={Styles['form-row-item-3']}>
                                        <div className={Styles['form-row-item-title3']}>
                                            {t('TaxClientNumber')}
                                        </div>
                                        <TextField
                                            fullWidth
                                            placeholder={t('TaxClientNumber')}
                                            value={formData.taxClientNumber}
                                            onChange={(e) => handleChange('taxClientNumber', e.target.value)}
                                            className={Styles['add-client-input-style']}
                                            variant="standard"
                                            InputProps={styledInput(direction, false)}
                                            inputProps={{
                                                style: {
                                                    textAlign: direction === 'ltr' ? 'left' : 'right',
                                                },
                                            }}
                                        />
                                    </div>

                                    <div className={Styles['form-row-item-3']}>
                                        <div className={Styles['form-row-item-title3']}>
                                            {t('VatClientNumber')}
                                        </div>
                                        <TextField
                                            fullWidth
                                            placeholder={t('VatClientNumber')}
                                            value={formData.vatClientNumber}
                                            onChange={(e) => handleChange('vatClientNumber', e.target.value)}
                                            className={Styles['add-client-input-style']}
                                            variant="standard"
                                            InputProps={styledInput(direction, false)}
                                            inputProps={{
                                                style: {
                                                    textAlign: direction === 'ltr' ? 'left' : 'right',
                                                },
                                            }}
                                        />
                                    </div>

                                    <div className={Styles['form-row-item-3']}>
                                        <div className={Styles['form-row-item-title3']}>
                                            {t('BusinessIdentificationNumberInOffice')}
                                        </div>
                                        <TextField
                                            fullWidth
                                            placeholder={t('BusinessIdentificationNumberInOffice')}
                                            value={formData.officeIdentifyNumber}
                                            onChange={(e) => handleChange('officeIdentifyNumber', e.target.value)}
                                            className={Styles['add-client-input-style']}
                                            variant="standard"
                                            name="unexpectedField_1234"
                                            type='number'
                                            InputProps={styledInput(direction, fieldErrors.officeIdentifyNumber)}
                                            inputProps={{
                                                style: {
                                                    textAlign: direction === 'ltr' ? 'left' : 'right',
                                                },
                                            }}
                                        />
                                    </div>

                                    <div className={Styles['form-row-item-3']}>
                                        <div className={Styles['form-row-item-title3']}>
                                            {t('BusinessEstablishmentDate')}
                                        </div>
                                        <div className={Styles['add-client-date-picker-field']}>
                                            <CustomDatePicker
                                                date={formData.businessEstablishmentDate || null}
                                                onDateChange={(date) => {
                                                    // The picker emits UTC midnight of the chosen day.
                                                    handleChange('businessEstablishmentDate', date ? date.toISOString().slice(0, 10) : '');
                                                }}
                                                height="48px"
                                                clearable
                                            />
                                        </div>
                                    </div>
                                    </>
                                    )}

                                    <div className={`${Styles['form-row-item-full']} ${Styles['add-client-section-container']}`}>
                                            <div className={`${Styles['section-title-text']} ${Styles['section-title-general']}`}>
                                                {t('GeneralDetails')}
                                            </div>
                                            <div className={Styles['add-client-section-container-fields']}>
                                                <div className={Styles['form-row-item-3']}>
                                                    <div className={Styles['form-row-item-title3']}>
                                                        {t('FirstPhoneNumber')}<span className="required-asterisk">*</span>
                                                    </div>
                                                    <TextField
                                                        fullWidth
                                                        placeholder={t('FirstPhoneNumber')}
                                                        value={formData.ClientPhoneNumber}
                                                        type="tel"
                                                        onChange={(e) => handleChange('ClientPhoneNumber', e.target.value)}
                                                        className={Styles['add-client-input-style']}
                                                        variant="standard"
                                                        InputProps={styledInput(direction, fieldErrors.ClientPhoneNumber)}
                                                        inputProps={{
                                                            style: {
                                                                textAlign: direction === 'ltr' ? 'left' : 'right',
                                                            },
                                                        }}
                                                        required
                                                    />
                                                </div>

                                                <div className={Styles['form-row-item-3']}>
                                                    <div className={Styles['form-row-item-title3']}>
                                                        {t('SecondPhoneNumberShort')}
                                                    </div>
                                                    <TextField
                                                        fullWidth
                                                        placeholder={t('SecondPhoneNumberShort')}
                                                        value={formData.ClientSecondaryPhoneNumber}
                                                        type="tel"
                                                        onChange={(e) => handleChange('ClientSecondaryPhoneNumber', e.target.value)}
                                                        className={Styles['add-client-input-style']}
                                                        variant="standard"
                                                        InputProps={styledInput(direction, false)}
                                                        inputProps={{
                                                            style: {
                                                                textAlign: direction === 'ltr' ? 'left' : 'right',
                                                            },
                                                        }}
                                                    />
                                                </div>

                                                {!isLimitedClient && (
                                                <div className={Styles['form-row-item-3']}>
                                                    <div className={Styles['form-row-item-title3']}>
                                                        {t('Location')}
                                                    </div>
                                                    <TextField
                                                        fullWidth
                                                        placeholder={t('Location')}
                                                        value={formData.ClientLocation}
                                                        onChange={(e) => handleChange('ClientLocation', e.target.value)}
                                                        className={Styles['add-client-input-style']}
                                                        variant="standard"
                                                        InputProps={styledInput(direction, false)}
                                                        inputProps={{
                                                            style: {
                                                                textAlign: direction === 'ltr' ? 'left' : 'right',
                                                            },
                                                        }}
                                                    />
                                                </div>
                                                )}

                                                <div className={Styles['form-row-item-3']}>
                                                    <div className={Styles['form-row-item-title3']}>
                                                        {t('Email')}
                                                    </div>
                                                    <TextField
                                                        fullWidth
                                                        placeholder={t('Email')}
                                                        value={formData.ClientEmail}
                                                        type='email'
                                                        onChange={(e) => handleChange('ClientEmail', e.target.value)}
                                                        className={Styles['add-client-input-style']}
                                                        variant="standard"
                                                        autoComplete="off"
                                                        name="email-unique-field"
                                                        InputProps={styledInput(direction, fieldErrors.ClientEmail)}
                                                        inputProps={{
                                                            style: {
                                                                textAlign: direction === 'ltr' ? 'left' : 'right',
                                                            },
                                                        }}
                                                    />
                                                </div>

                                                {!isLimitedClient && (
                                                <div className={Styles['form-row-item-3']}>
                                                    <div className={Styles['form-row-item-title3']}>
                                                        {t('Website')}
                                                    </div>
                                                    <TextField
                                                        fullWidth
                                                        placeholder={t('Website')}
                                                        value={formData.ClientWebsite}
                                                        onChange={(e) => handleChange('ClientWebsite', e.target.value)}
                                                        className={`${Styles['add-client-input-style']} full-width`}
                                                        variant="standard"
                                                        InputProps={{
                                                            disableUnderline: true,
                                                            className: `custom-input-box-sizing-toggle full-width ${direction === 'ltr' ? 'ltr-input' : 'rtl-input'}`,
                                                            sx: {
                                                                height: '38px',
                                                                padding: '0 10px',
                                                                borderRadius: '8px',
                                                                background: '#F5F5F6',
                                                                border: '1px solid transparent',
                                                                '&:focus-within': {
                                                                    border: '2px solid var(--Foundation-Blue-Normal, #304FFF)',
                                                                },
                                                            },
                                                        }}
                                                        inputProps={{
                                                            style: {
                                                                width: '100%',
                                                                textAlign: direction === 'ltr' ? 'left' : 'right',
                                                            },
                                                        }}
                                                    />
                                                </div>
                                                )}

                                                <div className={`${Styles['form-row-item-3']} ${Styles['form-row-item-full']}`}>
                                                    <div className={Styles['form-row-item-title3']}>
                                                        {t('Notes')}
                                                    </div>
                                                    <ClientNotesEditor
                                                        value={formData.ClientNotes}
                                                        onChange={(next) => handleChange('ClientNotes', next)}
                                                        direction={direction}
                                                        t={t}
                                                        editable
                                                        compact
                                                    />
                                                </div>

                                                {userTypeContext?.toString() !== Constants.UserType.Client && !isLimitedClient && (
                                                    <>
                                                        <div className={Styles['form-row-item-3']}>
                                                            <div className={Styles['form-row-item-title3']}>
                                                                {t('BusinessField')}
                                                            </div>
                                                            <Select
                                                                className={Styles['add-client-input-style']}
                                                                placeholder={t('BusinessField')}
                                                                options={formattedBusinessFieldOptions}
                                                                isSearchable={true}
                                                                onChange={(selectedOption) => {
                                                                    const businessFieldValue = selectedOption ? selectedOption.value : null;
                                                                    handleChange('businessField', businessFieldValue);

                                                                    // Auto-set payer based on business field (edit mode only).
                                                                    // In add mode we keep the default payer and let backend/UI handle it explicitly.
                                                                    if (isEdit) {
                                                                        // Auto-set payer to Client when VehicleDealership/Garage is selected
                                                                        if (businessFieldValue === Constants.VehicleDealership || businessFieldValue === Constants.Garage) {
                                                                            handleChange('clientPaymentMethod', 1); // Client (Business)
                                                                        } else if (businessFieldValue === null) {
                                                                            // Reset to Accountant when business field is cleared
                                                                            handleChange('clientPaymentMethod', 0); // Accountant
                                                                        }
                                                                    }
                                                                }}
                                                                value={formattedBusinessFieldOptions.find(option => option.value === formData.businessField)}
                                                                styles={customSelectStyles(false)}
                                                                isClearable={true}
                                                            />
                                                        </div>
                                                        <div className={Styles['form-row-item-3']}>
                                                            <div className={Styles['form-row-item-title3']}>
                                                                {t('EconomicBusinessBranch')}
                                                            </div>
                                                            <Select
                                                                className={Styles['add-client-input-style']}
                                                                placeholder={t('EconomicBusinessBranch')}
                                                                options={formattedIndustryOptions}
                                                                isSearchable={true}
                                                                onChange={(selectedOption) => {
                                                                    handleChange('economicBusinessBranch', selectedOption ? Number(selectedOption.value) : '');
                                                                }}
                                                                value={formattedIndustryOptions.find(option => option.value === Number(formData.economicBusinessBranch))}
                                                                styles={customSelectStyles(false)}
                                                                isClearable={true}
                                                            />
                                                        </div>
                                                        <div className={Styles['form-row-item-3']}>
                                                            <div className={Styles['form-row-item-title3']}>
                                                                {t('BusinessType') || 'סוג עסק'}<span className="required-asterisk">*</span>
                                                            </div>
                                                            <Select
                                                                className={Styles['add-client-input-style']}
                                                                placeholder={t('BusinessType') || 'סוג עסק'}
                                                                options={formattedBusinessTypeOptions}
                                                                isSearchable={false}
                                                                onChange={(selectedOption) => {
                                                                    handleChange('businessType', Number(selectedOption?.value ?? -1));
                                                                }}
                                                                value={formattedBusinessTypeOptions.find(option => option.value === Number(formData.businessType ?? -1))}
                                                                styles={customSelectStyles(false)}
                                                                menuPlacement="top"
                                                                maxMenuHeight={220}
                                                            />
                                                        </div>
                                                    </>
                                                )}

                                                {(isAccountant || isSubAccountant) && isEdit && (
                                                    <div className={`${Styles['form-row-item-3']} ${Styles['form-row-item-client-actions']}`}>
                                                        <div className={Styles['client-actions-row']}>
                                                            <FormControlLabel
                                                                className={Styles['client-actions-checkbox']}
                                                                control={
                                                                    <Checkbox
                                                                        checked={officePwd.isHave}
                                                                        onChange={(e) =>
                                                                            setOfficePwd((p) => ({ ...p, isHave: e.target.checked }))
                                                                        }
                                                                        color="primary"
                                                                        size="small"
                                                                    />
                                                                }
                                                                label={t("ProtectClientWithOfficePassword")}
                                                            />

                                                            <div className={Styles['client-actions-buttons']}>
                                                                {officePwd.isHave && (
                                                                    <Button
                                                                        variant="outlined"
                                                                        size="small"
                                                                        className={Styles['outline-action-button']}
                                                                        onClick={() => setOfficePwdDialogOpen(true)}
                                                                    >
                                                                        {officePwd.existsOnServer
                                                                            ? t("ChangeOfficePassword")
                                                                            : t("SetOfficePassword")}
                                                                    </Button>
                                                                )}

                                                                <Button
                                                                    variant="outlined"
                                                                    size="small"
                                                                    className={Styles['outline-action-button']}
                                                                    onClick={() => setResetPwdDialogOpen(true)}
                                                                >
                                                                    {t('ResetClientPassword')}
                                                                </Button>

                                                                {isAccountant && (
                                                                    <Button
                                                                        variant="outlined"
                                                                        color="primary"
                                                                        size="small"
                                                                        className={Styles['outline-action-button']}
                                                                        disabled={!formData.CaseID}
                                                                        onClick={() => setTransferModalOpen(true)}
                                                                    >
                                                                        {t('RequestTransfer')}
                                                                    </Button>
                                                                )}
                                                            </div>
                                                        </div>
                                                        {isAccountant && (
                                                            <Typography
                                                                variant="caption"
                                                                className={Styles['client-actions-hint']}
                                                            >
                                                                {t('RequestTransferHint')}
                                                            </Typography>
                                                        )}
                                                    </div>
                                                )}
                                                {isClient && (
                                                    <div className={`${Styles['form-row-item-3']} ${Styles['form-row-item-client-actions']}`}>
                                                        <div className={Styles['client-actions-row']}>
                                                            <div className={Styles['client-actions-buttons']}>
                                                                <Button
                                                                    variant="outlined"
                                                                    size="small"
                                                                    className={Styles['outline-action-button']}
                                                                    onClick={() => setResetPwdDialogOpen(true)}
                                                                >
                                                                    {t('ChangePassword')}
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}



                                            </div>
                                        </div>



                                    {/* Show initial password to client + accountant + sub-accountant
                                        while HasChangedInitialPassword is still false.
                                        Once the client changes their password, hide for everyone (incl. staff). */}
                                    {isEdit && (isClient || isAccountant || isSubAccountant) && !hasChangedInitialPassword && (
                                        <div className={`${Styles['form-row-item-3']} ${Styles['form-row-item-client-actions']}`}>
                                            <div className={Styles['form-row-item-title3']}>
                                                {t('InitialPassword')}
                                            </div>
                                            <div className={Styles['client-actions-row']}>
                                                <div className={Styles['client-actions-buttons']}>
                                                    <Button
                                                        variant="outlined"
                                                        size="small"
                                                        className={Styles['outline-action-button']}
                                                        onClick={openShowInitialPassword}
                                                        disabled={!formData.CaseID}
                                                    >
                                                        {t('ShowPassword')}
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                </div>
                            </div>



                            <div className={Styles['add-client-section-container']}>
                                <div className={`main-title2 ${direction}`} >
                                    <span className={Styles['section-title-text']}>{t('VATSettings')}</span>
                                </div>
                                <div className={Styles['add-client-section-container-fields']}>
                                    <div className={Styles['form-row-item-3']}>
                                        <div className={Styles['form-row-item-title3']}>
                                            {t('enterCaseType')}<span className="required-asterisk">*</span>
                                        </div>
                                        <Select
                                            className={Styles['add-client-input-style']}
                                            placeholder={t('enterCaseType')}
                                            options={formattedCaseTypeOptions}
                                            isSearchable={true}
                                            onChange={(selectedOption) => {
                                                const caseType = selectedOption.label;
                                                handleChange('CaseType', caseType);
                                                if (!Constants.TaxExemptTypes.includes(caseType)) {
                                                    handleChange('showVatPanelForTaxExempt', false);
                                                }

                                                // Auto-set isPartners based on CaseType
                                                if (caseType === 'שותפות') {
                                                    handleChange('isPartners', true);
                                                } else {
                                                    handleChange('isPartners', false);
                                                }
                                            }}
                                            value={formattedCaseTypeOptions.find(option => option.value === formData.CaseType)}

                                            styles={customSelectStyles(fieldErrors.CaseType)}
                                        />
                                    </div>

                                    {!isLimitedClient && (
                                    <>
                                    {isVatExempt && (
                                        <Box
                                            className={`${Styles['form-row-item-3']} ${Styles['add-client-vat-exempt-opt-in']}`}
                                            sx={{
                                                width: '100%',
                                                maxWidth: '100%',
                                                minWidth: 0,
                                            }}
                                        >
                                            <FormControlLabel
                                                sx={{
                                                    alignItems: 'flex-start',
                                                    mx: 0,
                                                    my: 0,
                                                    width: '100%',
                                                    maxWidth: '100%',
                                                    gap: 1,
                                                    '& .MuiCheckbox-root': { pt: 0.25 },
                                                    '& .MuiFormControlLabel-label': {
                                                        whiteSpace: 'normal',
                                                        wordBreak: 'break-word',
                                                        overflowWrap: 'anywhere',
                                                        fontSize: 'var(--xtram-text-sm, 14px)',
                                                        lineHeight: 1.35,
                                                    },
                                                }}
                                                control={
                                                    <Checkbox
                                                        checked={!!formData.showVatPanelForTaxExempt}
                                                        onChange={(e) => handleChange('showVatPanelForTaxExempt', e.target.checked)}
                                                        name="showVatPanelForTaxExempt"
                                                        color="primary"
                                                    />
                                                }
                                                label={t('ShowVatPanelForTaxExempt')}
                                            />
                                            <Typography
                                                variant="caption"
                                                component="div"
                                                sx={{
                                                    color: 'text.secondary',
                                                    mt: 0.5,
                                                    maxWidth: '100%',
                                                    whiteSpace: 'normal',
                                                    wordBreak: 'break-word',
                                                    overflowWrap: 'anywhere',
                                                    lineHeight: 1.4,
                                                }}
                                            >
                                                {t('ShowVatPanelForTaxExemptHelp')}
                                            </Typography>
                                        </Box>
                                    )}

                                    <div className={Styles['form-row-item-3']}>
                                        <div className={Styles['form-row-item-title3']}>
                                            {t('SelectClientReportType')}<span className="required-asterisk">*</span>
                                        </div>
                                        <Select
                                            className={Styles['add-client-input-style']}
                                            placeholder={t('SelectClientReportType')}
                                            options={formattedReportingTypeOptions}
                                            isSearchable={true}
                                            onChange={(selectedOption) => {
                                                handleChange('ClientReportingType', selectedOption.name);
                                            }}
                                            value={formattedReportingTypeOptions.find(option => option.value === formData.ClientReportingType)}
                                            isDisabled={isVatExempt}
                                            styles={customSelectStyles(fieldErrors.ClientReportingType)}
                                        />
                                    </div>



                                    <div className={`${Styles['form-row-item-3']} ${Styles['form-row-item-checkbox-inline']}`}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={formData.isRequiredToReportPCN874}
                                                    onChange={handlePCN874ReportingCheckboxChange}
                                                    name="PCN874ReportingObligation"
                                                    color="primary"
                                                />
                                            }
                                            label={t('PCN874ReportingObligation')}
                                        />
                                    </div>

                                    {formData.isPartners && (
                                        <div className={Styles['form-row-item-3']}>
                                            <Button
                                                variant="outlined"
                                                onClick={() => setPartnersModalOpen(true)}
                                                sx={{ mt: 1 }}
                                                style={{
                                                    border: '2px solid #304FFF',
                                                    color: '#304FFF',
                                                    fontWeight: '600',
                                                    borderRadius: '8px',
                                                    padding: '8px 16px',
                                                    textTransform: 'none'
                                                }}
                                            >
                                                {t('PartnersSettings')}
                                            </Button>
                                        </div>
                                    )}


                                    <div className={`main-title2 ${direction} ${Styles['section-title-spaced']}`} >
                                        <span className={Styles['section-title-text']}>{t('InstitutionBankSettings')}</span>
                                    </div>
                                    <div className={Styles['form-row-item-3']} >
                                        <div className={Styles['form-row-item-title3']}>
                                            {t('SelectPaymentMethod')}
                                        </div>
                                        <Select
                                            className={Styles['add-client-input-style']}
                                            placeholder={t('SelectPaymentMethod')}
                                            options={formattedPaymentMethodOptions}
                                            isSearchable={true}
                                            onChange={(selectedOption) => handleChange('bank.paymentMethod', selectedOption.value)}
                                            value={formattedPaymentMethodOptions.find(option => option.value === formData.bank.paymentMethod)}
                                            styles={customSelectStyles(false)}
                                            menuPlacement="top"
                                        />
                                    </div>

                                    <div className={Styles['form-row-item-3']}>
                                        <div className={Styles['form-row-item-title3']}>
                                            {t('BankCode')}
                                        </div>
                                        <TextField
                                            fullWidth
                                            placeholder={t('BankCode')}
                                            value={formData.bank.bankCode}
                                            onChange={(e) => handleChange('bank.bankCode', e.target.value)}
                                            className={Styles['add-client-input-style']}
                                            variant="standard"
                                            InputProps={styledInput(direction, false)}
                                            inputProps={{
                                                style: {
                                                    textAlign: direction === 'ltr' ? 'left' : 'right',
                                                },
                                            }}
                                        />
                                    </div>

                                    <div className={Styles['form-row-item-3']}>
                                        <div className={Styles['form-row-item-title3']}>
                                            {t('BranchNumber')}
                                        </div>
                                        <TextField
                                            fullWidth
                                            placeholder={t('BranchNumber')}
                                            value={formData.bank.branchNumber}
                                            onChange={(e) => handleChange('bank.branchNumber', e.target.value)}
                                            className={Styles['add-client-input-style']}
                                            variant="standard"
                                            InputProps={styledInput(direction, false)}
                                            inputProps={{
                                                style: {
                                                    textAlign: direction === 'ltr' ? 'left' : 'right',
                                                },
                                            }}
                                        />
                                    </div>

                                    <div className={Styles['form-row-item-3']}>
                                        <div className={Styles['form-row-item-title3']}>
                                            {t('AccountNumber')}
                                        </div>
                                        <TextField
                                            fullWidth
                                            placeholder={t('AccountNumber')}
                                            value={formData.bank.accountNumber}
                                            onChange={(e) => handleChange('bank.accountNumber', e.target.value)}
                                            className={Styles['add-client-input-style']}
                                            variant="standard"
                                            InputProps={styledInput(direction, false)}
                                            inputProps={{
                                                style: {
                                                    textAlign: direction === 'ltr' ? 'left' : 'right',
                                                },
                                            }}
                                        />
                                    </div>
                                    </>
                                    )}

                                </div>
                            </div>




                            {!isLimitedClient && (
                            <div className={Styles['add-client-section-container']}>
                                <div className={`main-title2 ${direction}`} >
                                    <span className={Styles['section-title-text']}>{t('IncomeTaxSettings')}</span>
                                </div>
                                <div className={Styles['add-client-section-container-fields']}>

                                    <div className={Styles['form-row-item-3']}>
                                        <div className={Styles['form-row-item-title3']}>
                                            {t('SelectAccountManagement')}<span className="required-asterisk">*</span>
                                        </div>
                                        <Select
                                            className={Styles['add-client-input-style']}
                                            placeholder={t('SelectAccountManagement')}
                                            options={formattedAccountManagementOptions}
                                            isSearchable={true}
                                            onChange={(selectedOption) => {
                                                handleChange('AccountManagement', selectedOption.name);
                                            }}
                                            value={formattedAccountManagementOptions.find(option => option.value === formData.AccountManagement)}

                                            styles={customSelectStyles(fieldErrors.AccountManagement)}
                                        />
                                    </div>

                                    <div className={Styles['form-row-item-3']}>
                                        <div className={Styles['form-row-item-title3']}>
                                            {t('DeductionsCase')}
                                        </div>
                                        <TextField
                                            fullWidth
                                            type="number"
                                            placeholder={t('DeductionsCase')}
                                            value={formData.deductionsCase}
                                            onChange={(e) => handleChange('deductionsCase', e.target.value)}
                                            className={Styles['add-client-input-style']}
                                            variant="standard"
                                            InputProps={{
                                                disableUnderline: true,
                                                className: `custom-input-box-sizing-toggle ${direction === 'ltr' ? 'ltr-input' : 'rtl-input'}`,
                                                sx: {
                                                    height: '38px',
                                                    padding: '0 10px',
                                                    borderRadius: '8px',
                                                    background: '#F5F5F6',
                                                    border: '1px solid transparent',
                                                    '&:focus-within': {
                                                        border: '2px solid var(--Foundation-Blue-Normal, #304FFF)',
                                                    },
                                                },
                                            }}
                                            inputProps={{
                                                style: {
                                                    textAlign: direction === 'ltr' ? 'left' : 'right',
                                                },
                                            }}
                                        />
                                    </div>

                                    <div className={Styles['form-row-item-3']}>
                                        <div className={Styles['form-row-item-title3']}>
                                            {t('IncomeTaxCreditPoints')}
                                        </div>
                                        <TextField
                                            fullWidth
                                            placeholder={t('IncomeTaxCreditPoints')}
                                            value={formData.taxCreditPoints}
                                            onChange={(e) => handleChange('taxCreditPoints', e.target.value)}
                                            className={`${Styles['add-client-input-style']} full-width`}
                                            variant="standard"
                                            type="number"
                                            InputProps={{
                                                disableUnderline: true,
                                                className: `custom-input-box-sizing-toggle full-width ${direction === 'ltr' ? 'ltr-input' : 'rtl-input'}`,
                                                sx: {
                                                    height: '38px',
                                                    padding: '0 10px',
                                                    borderRadius: '8px',
                                                    background: '#F5F5F6',
                                                    border: '1px solid transparent',
                                                    '&:focus-within': {
                                                        border: '2px solid var(--Foundation-Blue-Normal, #304FFF)',
                                                    },
                                                },
                                            }}
                                            inputProps={{
                                                style: {
                                                    width: '100%',
                                                    textAlign: direction === 'ltr' ? 'left' : 'right',
                                                },
                                            }}
                                        />
                                    </div>

                                    <div className={Styles['form-row-item-3']}>
                                        <div className={Styles['form-row-item-title3']}>
                                            {t('TaxAssessor')}
                                        </div>
                                        <Select
                                            className={Styles['add-client-input-style']}
                                            placeholder={t('TaxAssessor')}
                                            options={Constants.TaxAssessorOptions}
                                            isSearchable={true}
                                            onChange={(selectedOption) => {
                                                handleChange('taxAssessor', selectedOption.value);
                                            }}
                                            value={Constants.TaxAssessorOptions.find(option => option.value === formData.taxAssessor)}
                                            styles={customSelectStyles(false)}
                                        />
                                    </div>
                                    {!formData.isPartners && (
                                        <>
                                            <div className={`${Styles['form-row-item-3']} ${Styles['form-row-item-checkbox-inline']}`}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={formData.useIncomeTaxAdvancePercentage}
                                                            onChange={handleCheckboxChange}
                                                            name="useIncomeTaxAdvancePercentage"
                                                            color="primary"
                                                        />
                                                    }
                                                    label={t('UseIncomeTaxAdvancePercentage')}
                                                />
                                            </div>

                                            {formData.useIncomeTaxAdvancePercentage ? (
                                                <div className={Styles['form-row-item-3']}>

                                                    <div className={Styles['form-row-item-title3']}>
                                                        {t('IncomeTaxAdvancePercentage')}
                                                    </div>
                                                    <TextField
                                                        fullWidth
                                                        placeholder={t('IncomeTaxAdvancePercentage')}
                                                        value={formData.incomeTaxAdvancePercentage}
                                                        onChange={(e) => {
                                                            let value = e.target.value.replace(',', '.');
                                                            if (/^\d*\.?\d*$/.test(value)) {
                                                                handleChange('incomeTaxAdvancePercentage', value);
                                                            }
                                                        }}
                                                        className={`${Styles['add-client-input-style']} full-width`}
                                                        variant="standard"
                                                        type="text"
                                                        InputProps={styledInput(direction, false)}
                                                        inputProps={{
                                                            style: {
                                                                width: '100%',
                                                                textAlign: direction === 'ltr' ? 'left' : 'right',
                                                            },
                                                        }}
                                                    />

                                                </div>
                                            ) : (
                                                <div className={Styles['form-row-item-3']}>
                                                    <div className={Styles['form-row-item-title3']}>
                                                        {t('SumIncomeTaxAdvancePercentage')}
                                                    </div>
                                                    <TextField
                                                        fullWidth
                                                        placeholder={t('SumIncomeTaxAdvancePercentage')}
                                                        value={formData.incomeTaxAdvanceAmount}
                                                        onChange={(e) => handleChange('incomeTaxAdvanceAmount', e.target.value)}
                                                        className={`${Styles['add-client-input-style']} full-width`}
                                                        variant="standard"
                                                        type="number"
                                                        InputProps={styledInput(direction, false)}
                                                        inputProps={{
                                                            style: {
                                                                width: '100%',
                                                                textAlign: direction === 'ltr' ? 'left' : 'right',
                                                            },
                                                        }}
                                                    />

                                                </div>
                                            )}
                                            {isEdit && formData.CaseID && (
                                                <div className={`${Styles['form-row-item-3']} ${Styles['form-row-item-action-inline']}`}>
                                                    <Button variant="outlined" size="small" onClick={() => setYearlyTaxAdvanceModalOpen(true)}>
                                                        {t('ManageYearlyTaxAdvance')}
                                                    </Button>
                                                    <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                                                        {t('ManageYearlyTaxAdvanceEntryHint')}
                                                    </Typography>
                                                </div>
                                            )}
                                            {/* Case Relationship Settings - Only show for non-client users */}
                                            {!isClient && (
                                                <>
                                                    <div className={Styles['form-row-item-3']}>
                                                        <FormControlLabel
                                                            style={{ width: '100%' }}
                                                            control={
                                                                <Checkbox
                                                                    checked={formData.isSharedReporting}
                                                                    onChange={(e) => {
                                                                        handleChange('isSharedReporting', e.target.checked);
                                                                        if (!e.target.checked) {
                                                                            // Reset relationship data when unchecked
                                                                            handleChange('relationshipType', '');
                                                                            handleChange('relatedCaseId', '');
                                                                        }
                                                                    }}
                                                                    name="isSharedReporting"
                                                                    color="primary"
                                                                />
                                                            }
                                                            label={t('SharedAdvanceReporting')}
                                                        />
                                                    </div>

                                                    {formData.isSharedReporting && (
                                                        <>
                                                            {existingRelationshipData && (
                                                                <div style={{
                                                                    display: 'flex', alignItems: 'center', gap: '10px',
                                                                    padding: '8px 12px', background: '#f0f2ff', borderRadius: '8px',
                                                                    border: '1px solid #d4d9ff', marginBottom: '8px'
                                                                }}>
                                                                    <span style={{ fontSize: 'var(--xtram-header-btn-font, 13px)', fontWeight: 600, color: '#304FFF' }}>
                                                                        {existingRelationshipData.type === 'main' ? t('MainCase') : t('SubordinateCase')}:
                                                                    </span>
                                                                    <span style={{ fontSize: 'var(--xtram-header-btn-font, 13px)', color: '#333' }}>
                                                                        {existingRelationshipData.relatedCaseName} ({existingRelationshipData.relatedCaseId})
                                                                    </span>
                                                                    <button
                                                                        onClick={handleRemoveRelationship}
                                                                        style={{
                                                                            marginInlineStart: 'auto', background: '#d32f2f', color: '#fff',
                                                                            border: 'none', borderRadius: '6px', padding: '4px 12px',
                                                                            fontSize: 'var(--xtram-header-compact-font, 12px)', fontWeight: 600, cursor: 'pointer'
                                                                        }}
                                                                    >
                                                                        {t('Remove') || 'Remove'}
                                                                    </button>
                                                                </div>
                                                            )}

                                                            <div className={Styles['form-row-item-3']}>
                                                                <div className={Styles['form-row-item-title3']}>
                                                                    {t('RelationshipType')}<span className="required-asterisk">*</span>
                                                                </div>
                                                                <Select
                                                                    className={Styles['add-client-input-style']}
                                                                    placeholder={t('RelationshipType')}
                                                                    options={[
                                                                        { label: t('MainCase'), value: 'main' },
                                                                        { label: t('SubordinateCase'), value: 'subordinate' }
                                                                    ]}
                                                                    isSearchable={false}
                                                                    onChange={(selectedOption) => {
                                                                        handleChange('relationshipType', selectedOption.value);
                                                                        handleChange('relatedCaseId', '');
                                                                    }}
                                                                    value={formData.relationshipType ?
                                                                        { label: formData.relationshipType === 'main' ? t('MainCase') : t('SubordinateCase'), value: formData.relationshipType }
                                                                        : null
                                                                    }
                                                                    styles={customSelectStyles(fieldErrors.relationshipType)}
                                                                />
                                                            </div>

                                                            {formData.relationshipType && (
                                                                <div className={Styles['form-row-item-3']}>
                                                                    <div className={Styles['form-row-item-title3']}>
                                                                        {formData.relationshipType === 'main' ? t('SelectSubordinateCase') : t('SelectMainCase')}
                                                                        <span className="required-asterisk">*</span>
                                                                    </div>
                                                                    <Select
                                                                        className={Styles['add-client-input-style']}
                                                                        placeholder={formData.relationshipType === 'main' ? t('SelectSubordinateCase') : t('SelectMainCase')}
                                                                        options={availableClients.map(client => ({
                                                                            label: `${client.name} (${client.caseId})`,
                                                                            value: client.caseId
                                                                        }))}
                                                                        isSearchable={true}
                                                                        onChange={(selectedOption) => {
                                                                            handleChange('relatedCaseId', selectedOption ? selectedOption.value : '');
                                                                        }}
                                                                        value={formData.relatedCaseId ?
                                                                            (() => {
                                                                                const client = availableClients.find(c => c.caseId === formData.relatedCaseId);
                                                                                return client ? { label: `${client.name} (${client.caseId})`, value: client.caseId } : null;
                                                                            })()
                                                                            : null
                                                                        }
                                                                        styles={customSelectStyles(fieldErrors.relatedCaseId)}
                                                                    />
                                                                </div>
                                                            )}
                                                        </>
                                                    )}
                                                </>
                                            )}
                                        </>
                                    )}
                                    <div className={Styles['form-row-item-3']}>
                                        <div className={Styles['form-row-item-title3']}>
                                            {t('AdvanceIncomeTaxReportType')}<span className="required-asterisk">*</span>
                                        </div>
                                        <Select
                                            className={Styles['add-client-input-style']}
                                            placeholder={t('AdvanceIncomeTaxReportType')}
                                            options={formattedReportingTypeOptions}
                                            isSearchable={true}
                                            onChange={(selectedOption) => {
                                                handleChange('advancedReportingType', selectedOption.name);
                                            }}
                                            value={formattedReportingTypeOptions.find(option => option.value === formData.advancedReportingType)}
                                            isDisabled={isVatExempt && !formData.showVatPanelForTaxExempt}
                                            styles={customSelectStyles(fieldErrors.advancedReportingType)}
                                        />
                                    </div>
                                    {/* Withholding Tax Percentage */}
                                    <div className={Styles['form-row-item-3']}>
                                        <div className={Styles['form-row-item-title3']}>
                                            {t('WithholdingTaxPercentage')}
                                        </div>
                                        <TextField
                                            fullWidth
                                            type="number"
                                            placeholder={t('WithholdingTaxPercentage')}
                                            value={formData.withholdingTaxPercentage || ''}
                                            onChange={(e) => handleChange('withholdingTaxPercentage', e.target.value)}
                                            className={`${Styles['add-client-input-style']} full-width`}
                                            variant="standard"
                                            InputProps={styledInput(direction, fieldErrors.withholdingTaxPercentage)}
                                            inputProps={{
                                                style: {
                                                    width: '100%',
                                                    textAlign: direction === 'ltr' ? 'left' : 'right',
                                                },
                                            }}
                                        />
                                    </div>

                                    {/* Withholding Tax Approval Valid Until */}
                                    <div className={Styles['form-row-item-3']}>
                                        <div className={Styles['form-row-item-title3']}>
                                            {t('WithholdingTaxApprovalValidity')}
                                        </div>
                                        <div className={Styles['add-client-date-picker-field']}>
                                            <CustomDatePicker
                                                date={
                                                    formData.withholdingTaxApprovalValidUntil
                                                        ? formData.withholdingTaxApprovalValidUntil
                                                        : null
                                                }
                                                onDateChange={(date) => {
                                                    if (date) {
                                                        handleChange('withholdingTaxApprovalValidUntil', date.toISOString());
                                                    } else {
                                                        handleChange('withholdingTaxApprovalValidUntil', null);
                                                    }
                                                }}
                                                height="48px"
                                            />
                                        </div>
                                    </div>


                                </div>
                            </div>
                            )}

                            <div className={Styles['add-client-section-container']}>

                                {/* <div className={`main-title2 ${direction}`} >
                                    {t('InvoiceSetting')}
                                </div>
                                <div className={Styles['add-client-section-container-fields']}>
                                    <div className={Styles['form-row-item-3']}>
                                        {isEdit && (
                                            <button
                                                onClick={() => setOpenSignatureDialog(true)}
                                                style={{
                                                    width: '80%',
                                                    padding: '14px 24px',
                                                    background: '#ffffff',
                                                    border: '2px solid #304FFF',
                                                    borderRadius: '12px',
                                                    color: '#304FFF',
                                                    fontWeight: '600',
                                                    fontSize: 'var(--xtram-panel-section, 15px)',
                                                    fontFamily: "'Heebo', sans-serif",
                                                    cursor: 'pointer',
                                                    transition: 'all 0.3s ease',
                                                    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.06)',
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.target.style.background = '#F0F3FF';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.target.style.background = '#ffffff';
                                                }}
                                            >
                                                {t('EditSignatureOrProfilePicture')}
                                            </button>
                                        )}
                                    </div>
                                    <div className={Styles['form-row-item-3']}>
                                        <div className={Styles['form-row-item-title3']}>
                                            {t('InvoiceDescription')}
                                        </div>
                                        <TextField
                                            fullWidth
                                            placeholder={t('InvoiceDescription')}
                                            value={constantClientDescription}
                                            onChange={(e) => setConstantClientDescription(e.target.value)}
                                            className={`${Styles['add-client-input-style']} full-width`}
                                            variant="standard"
                                            multiline
                                            rows={2} 
                                            InputProps={{
                                                disableUnderline: true,
                                                className: `custom-input-box-sizing-toggle full-width ${direction === 'ltr' ? 'ltr-input' : 'rtl-input'}`,
                                                sx: {
                                                    padding: '10px',
                                                    borderRadius: '8px',
                                                    background: '#F5F5F6',
                                                    border: '1px solid transparent',
                                                    '&:focus-within': {
                                                        border: '2px solid var(--Foundation-Blue-Normal, #304FFF)',
                                                    },
                                                },
                                            }}
                                            inputProps={{
                                                style: {
                                                    width: '100%',
                                                    textAlign: direction === 'ltr' ? 'left' : 'right',
                                                },
                                            }}
                                        />
                                    </div>
                                    <div className={Styles['form-row-item-3']} style={{ marginTop: '25px' }}>
                                        <div className={Styles['form-row-item-title3']}>
                                            {t('InvoiceFooter')}
                                        </div>
                                        <TextField
                                            fullWidth
                                            placeholder={t('InvoiceFooter')}
                                            value={constantInvoiceDescription}
                                            onChange={(e) => setConstantInvoiceDescription(e.target.value)}
                                            className={`${Styles['add-client-input-style']} full-width`}
                                            variant="standard"
                                            multiline
                                            rows={2} // Default number of rows
                                            InputProps={{
                                                disableUnderline: true,
                                                className: `custom-input-box-sizing-toggle full-width ${direction === 'ltr' ? 'ltr-input' : 'rtl-input'}`,
                                                sx: {
                                                    padding: '10px', // Adjust padding for multi-line input
                                                    borderRadius: '8px',
                                                    background: '#F5F5F6',
                                                    border: '1px solid transparent',
                                                    '&:focus-within': {
                                                        border: '2px solid var(--Foundation-Blue-Normal, #304FFF)',
                                                    },
                                                },
                                            }}
                                            inputProps={{
                                                style: {
                                                    width: '100%',
                                                    textAlign: direction === 'ltr' ? 'left' : 'right',
                                                },
                                            }}
                                        />
                                    </div>
                                </div> */}

                                <div className={Styles['add-client-section-container-fields']}>
                                    {
                                        showPackageSettings &&
                                        <>

                                            <div className={`main-title2 ${direction}`}>
                                                <span className={Styles['section-title-text']}>{t('PackageAndPaymentSetupForXtram')}</span>
                                            </div>

                                            <div className={Styles['form-row-item-package-fields']}>
                                                <div className={Styles['form-row-item-3']}>
                                                    <div className={Styles['form-row-item-title3']}>
                                                        {t('SubAccountant')}
                                                    </div>
                                                    <Select
                                                        className={Styles['add-client-input-style']}
                                                        placeholder={t('SubAccountant')}
                                                        options={formattedSubAccOptions}
                                                        isSearchable={true}
                                                        onChange={(selectedOption) => {
                                                            handleChange('subAccId', selectedOption.value);
                                                        }}
                                                        value={formattedSubAccOptions.find(option => option.value === formData.subAccId)}

                                                        styles={customSelectStyles(false)}
                                                    />
                                                </div>
                                                {/* Row 10: Bank code, Branch number */}
                                                {isEdit && (
                                                    <div className={`${Styles['form-row-item-3']} ${Styles['form-row-item-payer']}`}>
                                                        <div className={Styles['form-row-item-title3']}>
                                                            {t('Payer')}
                                                        </div>
                                                        <Select
                                                            className={Styles['add-client-input-style']}
                                                            placeholder={t('Payer')}
                                                            options={translatedClientPaymentMethodOptions}
                                                            isSearchable={false}
                                                            onChange={async (selectedOption) => {
                                                                const newPaymentMethod = selectedOption.value;

                                                                logPayerCard('Payer Select onChange', {
                                                                    newPaymentMethod,
                                                                    currentFormPayer: formData.clientPaymentMethod,
                                                                    locationStateClientPayer: client?.clientPaymentMethod,
                                                                    serverOriginalClientPaymentMethod,
                                                                    baselineClientPaymentMethod,
                                                                    caseId: formData.CaseID,
                                                                    isEdit,
                                                                    accountantEnum: Constants.clientPaymentMethodOptionsEnum.Accountant,
                                                                    clientEnum: Constants.clientPaymentMethodOptionsEnum.Client
                                                                });

                                                                const prevPayer = formData.clientPaymentMethod;
                                                                const switchingFromAccountantToClient =
                                                                    newPaymentMethod === Constants.clientPaymentMethodOptionsEnum.Client &&
                                                                    (prevPayer === Constants.clientPaymentMethodOptionsEnum.Accountant ||
                                                                        (prevPayer == null &&
                                                                            baselineClientPaymentMethod === Constants.clientPaymentMethodOptionsEnum.Accountant));

                                                                if (switchingFromAccountantToClient) {
                                                                    logPayerCard('Branch: Accountant → Client');
                                                                    // Switching from Accountant -> Client:
                                                                    // If the client has no saved card, we must show the credit-card modal.
                                                                    try {
                                                                        const savedCard = await PaymentService.client.getPaymentMethod(formData.CaseID);
                                                                        logPayerCard('getPaymentMethod result', {
                                                                            caseId: formData.CaseID,
                                                                            savedCard,
                                                                            truthy: !!savedCard
                                                                        });
                                                                        if (!savedCard) {
                                                                            logPayerCard('No saved card → setShowSwitchModal(true)');
                                                                            pendingPayerSwitchRef.current = {
                                                                                previousPaymentMethod: formData.clientPaymentMethod
                                                                            };
                                                                            handleChange('clientPaymentMethod', newPaymentMethod);
                                                                            setShowSwitchModal(true);
                                                                            return;
                                                                        }
                                                                    } catch (err) {
                                                                        logPayerCard('getPaymentMethod threw → show modal anyway', err);
                                                                        // If we can't verify, fall back to showing the modal so the user can add a card.
                                                                        pendingPayerSwitchRef.current = {
                                                                            previousPaymentMethod: formData.clientPaymentMethod
                                                                        };
                                                                        handleChange('clientPaymentMethod', newPaymentMethod);
                                                                        setShowSwitchModal(true);
                                                                        return;
                                                                    }

                                                                    // Client already has a saved card. Still check if credit card was declined before.
                                                                    try {
                                                                        const response = await fetch(`${config[selectedEnvironment].API_URL}/PaymentTransactionLogs/user/${formData.CaseID}/has-declined`, {
                                                                            method: 'GET',
                                                                            headers: {
                                                                                "Authorization": 'Bearer ' + token,
                                                                                "Content-Type": "application/json",
                                                                            }
                                                                        });

                                                                        if (response.ok) {
                                                                            const data = await response.json();
                                                                            if (data.hasDeclined) {
                                                                                logPayerCard('hasDeclined=true → Swal prompt');
                                                                                // Credit card was declined before - ask for new card
                                                                                const result = await Swal.fire({
                                                                                    title: t('creditCardDeclined') || 'כרטיס אשראי נדחה בעבר',
                                                                                    text: t('creditCardDeclinedMessage') || 'כרטיס האשראי של הלקוח נדחה בעבר. האם ברצונך להוסיף כרטיס אשראי חדש?',
                                                                                    icon: 'warning',
                                                                                    showCancelButton: true,
                                                                                    confirmButtonText: t('yes') || 'כן',
                                                                                    cancelButtonText: t('no') || 'לא'
                                                                                });

                                                                                if (result.isConfirmed) {
                                                                                    logPayerCard('User confirmed Swal → setShowSwitchModal(true)');
                                                                                    // User wants to add new card - show switch modal
                                                                                    pendingPayerSwitchRef.current = {
                                                                                        previousPaymentMethod: formData.clientPaymentMethod
                                                                                    };
                                                                                    handleChange('clientPaymentMethod', newPaymentMethod);
                                                                                    setShowSwitchModal(true);
                                                                                    return; // Don't change payment method yet, wait for card to be added
                                                                                } else {
                                                                                    logPayerCard('User cancelled Swal → payer unchanged');
                                                                                    // User cancelled - don't change payment method
                                                                                    return;
                                                                                }
                                                                            }
                                                                        }
                                                                    } catch (error) {
                                                                        logPayerCard('has-declined check failed', error);
                                                                        console.error('Error checking declined transactions:', error);
                                                                        // Continue with payment method change even if check fails
                                                                    }
                                                                    logPayerCard('Has saved card and no declined (or check skipped) → payer updated only, no modal from Select');
                                                                } else {
                                                                    logPayerCard('Skipped Accountant→Client branch (see enums above). Applying payer change only.');
                                                                }

                                                                handleChange('clientPaymentMethod', newPaymentMethod);
                                                            }}
                                                            value={translatedClientPaymentMethodOptions.find(option => option.value === formData.clientPaymentMethod)}
                                                            styles={customSelectStyles(false)}
                                                            isDisabled={formData.businessField === Constants.VehicleDealership || formData.businessField === Constants.Garage}
                                                        />
                                                        {formData.businessField === Constants.VehicleDealership && (
                                                            <div className={Styles['field-hint-error']}>
                                                                {t('VehicleDealershipClientsMustBeBusinessPayer')}
                                                            </div>
                                                        )}
                                                        {formData.businessField === Constants.Garage && (
                                                            <div className={Styles['field-hint-error']}>
                                                                {t('GarageClientsMustBeBusinessPayer')}
                                                            </div>
                                                        )}
                                                        {(formData.businessField === Constants.VehicleDealership || formData.businessField === Constants.Garage) && formData.CaseID && (
                                                            <button
                                                                type="button"
                                                                onClick={() => {
                                                                    pendingPayerSwitchRef.current = { previousPaymentMethod: formData.clientPaymentMethod };
                                                                    setShowSwitchModal(true);
                                                                }}
                                                                className={Styles['outline-action-button']}
                                                            >
                                                                {t('AddClientCreditCard')}
                                                            </button>
                                                        )}
                                                    </div>
                                                )}
                                            </div>

                                            {isEdit && formData.clientPaymentMethod === Constants.clientPaymentMethodOptionsEnum.Client && (
                                                <div className={Styles['form-row-item-3']}>
                                                    <div className={Styles['form-row-item-title3']}>
                                                        {t('FinsitePayer')}
                                                    </div>
                                                    <Select
                                                        className={Styles['add-client-input-style']}
                                                        placeholder={t('FinsitePayer')}
                                                        options={finsitePayerOptions}
                                                        isSearchable={false}
                                                        onChange={(selectedOption) => handleChange('finsitePaidByClient', selectedOption.value)}
                                                        value={finsitePayerOptions.find(option => option.value === !!formData.finsitePaidByClient)}
                                                        styles={customSelectStyles(false)}
                                                    />
                                                    <Typography
                                                        variant="caption"
                                                        component="div"
                                                        sx={{ color: 'text.secondary', mt: 0.5, whiteSpace: 'normal', lineHeight: 1.35 }}
                                                    >
                                                        {t('FinsitePayerHelp')}
                                                    </Typography>
                                                </div>
                                            )}

                                            {!isLimitedClient && (
                                            <div className={Styles['form-row-item-3']}>
                                                <div className={Styles['form-row-item-title3']}>
                                                    {t('Package')}
                                                </div>
                                                <Select
                                                    className={Styles['add-client-input-style']}
                                                    placeholder={t('Package')}
                                                    options={translatedPackageOptions}
                                                    isSearchable={false}
                                                    onChange={(selectedOption) => {
                                                        handleChange('package', selectedOption.value);
                                                    }}
                                                    value={translatedPackageOptions.find(option => option.value === formData.package)}
                                                    styles={customSelectStyles(false)}
                                                />
                                            </div>
                                            )}

                                            {(!isEdit || originalManageOnly) && (
                                                <div className={Styles['form-row-item-3']}>
                                                    <div className={Styles['form-row-item-title3']}>{t("ClientType")}</div>
                                                    {(() => {
                                                        // In edit mode the only allowed change is a downgrade to Regular.
                                                        // Switching to ManageOnly / TaxRefund for an existing client is
                                                        // done from the manager dashboard (accountant arrangement view).
                                                        const originalClientType = !originalManageOnly
                                                            ? 'regular'
                                                            : (originalTaxRefund ? 'taxRefund' : 'manageOnly');
                                                        const isLocked = (type) => isEdit && type !== 'regular' && type !== originalClientType;
                                                        const clientTypeOptions = [
                                                            { label: t('RegularClient'), value: 'regular' },
                                                            { label: t('ManageOnly'), value: 'manageOnly', isDisabled: isLocked('manageOnly') },
                                                            { label: t('TaxRefundClient'), value: 'taxRefund', isDisabled: isLocked('taxRefund') },
                                                        ];
                                                        const currentClientType = !formData.manageOnly
                                                            ? 'regular'
                                                            : (formData.taxRefund ? 'taxRefund' : 'manageOnly');
                                                        return (
                                                            <Select
                                                                className={Styles['add-client-input-style']}
                                                                placeholder={t('ClientType')}
                                                                options={clientTypeOptions}
                                                                isOptionDisabled={(option) => option.isDisabled}
                                                                isSearchable={false}
                                                                onChange={(selectedOption) => {
                                                                    handleChange('manageOnly', selectedOption.value !== 'regular');
                                                                    handleChange('taxRefund', selectedOption.value === 'taxRefund');
                                                                }}
                                                                value={clientTypeOptions.find(option => option.value === currentClientType)}
                                                                styles={customSelectStyles(false)}
                                                            />
                                                        );
                                                    })()}
                                                    {isEdit && (
                                                        <Typography
                                                            variant="caption"
                                                            component="div"
                                                            sx={{ color: 'text.secondary', mt: 0.5, whiteSpace: 'normal', lineHeight: 1.35 }}
                                                        >
                                                            {t('ClientTypeEditHint')}
                                                        </Typography>
                                                    )}
                                                </div>
                                            )}

                                        </>

                                    }

                                    {
                                        showClientBusinessSettings && !isLimitedClient &&
                                        <>
                                            <Divider className={Styles['form-row-item-full']} sx={{ width: '100%', my: 0.5 }} />
                                            {(!otherLeadingExists || client?.leadingBusiness) && (
                                                <div className={Styles['form-row-item-3']}>
                                                    <div className={Styles['form-row-item-title3']}>{t("LeadingBusiness")}</div>
                                                    <Select
                                                        className={Styles['add-client-input-style']}
                                                        placeholder={t("LeadingBusiness")}
                                                        options={[
                                                            { label: t("Yes"), value: true },
                                                            { label: t("No"), value: false }
                                                        ]}
                                                        value={{
                                                            label: formData.leadingBusiness ? t("Yes") : t("No"),
                                                            value: formData.leadingBusiness
                                                        }}
                                                        onChange={(selectedOption) => {
                                                            handleChange('leadingBusiness', selectedOption.value);
                                                        }}
                                                        styles={customSelectStyles(false)}
                                                        isSearchable={false}
                                                    />
                                                </div>
                                            )}
                                            <div className={Styles['form-row-item-3']}>
                                                <div className={Styles['form-row-item-title3']}>{t("InventoryManagingBusiness")}</div>
                                                <Select
                                                    className={Styles['add-client-input-style']}
                                                    placeholder={t("InventoryManagingBusiness")}
                                                    options={[
                                                        { label: t("Yes"), value: true },
                                                        { label: t("No"), value: false }
                                                    ]}
                                                    value={{
                                                        label: formData.managesInventory ? t("Yes") : t("No"),
                                                        value: formData.managesInventory
                                                    }}
                                                    onChange={(selectedOption) => {
                                                        handleChange('managesInventory', selectedOption.value);
                                                    }}
                                                    styles={customSelectStyles(false)}
                                                    isSearchable={false}
                                                />
                                            </div>
                                            <div className={Styles['form-row-item-3']}>
                                                <div className={Styles['form-row-item-title3']}>{t("ProjectManagingBusiness")}</div>
                                                <Select
                                                    className={Styles['add-client-input-style']}
                                                    placeholder={t("ProjectManagingBusiness")}
                                                    options={[
                                                        { label: t("Yes"), value: true },
                                                        { label: t("No"), value: false }
                                                    ]}
                                                    value={{
                                                        label: formData.managesProject ? t("Yes") : t("No"),
                                                        value: formData.managesProject
                                                    }}
                                                    onChange={(selectedOption) => {
                                                        handleChange('managesProject', selectedOption.value);
                                                    }}
                                                    styles={customSelectStyles(false)}
                                                    isSearchable={false}
                                                />
                                            </div>
                                            <div className={Styles['form-row-item-3']}>
                                                <div className={Styles['form-row-item-title3']}>{t("ClientCanViewVatAndTaxAdvances")}</div>
                                                <Select
                                                    className={Styles['add-client-input-style']}
                                                    placeholder={t('ClientCanViewVatAndTaxAdvances')}
                                                    value={{
                                                        label: formData.canSeeVat ? t('Yes') : t('No'),
                                                        value: formData.canSeeVat,
                                                    }}
                                                    onChange={(opt) => handleChange('canSeeVat', opt.value)}
                                                    options={[
                                                        { label: t('Yes'), value: true, isDisabled: isVatExempt },
                                                        { label: t('No'), value: false, isDisabled: isVatExempt },
                                                    ]}
                                                    isOptionDisabled={(option) => option.isDisabled}
                                                    styles={customSelectStyles(false)}
                                                    isSearchable={false}
                                                />
                                            </div>
                                            <div className={Styles['form-row-item-3']}>
                                                <div className={Styles['form-row-item-title3']}>{t("ClientCanViewDocumentStatus")}</div>
                                                <Select
                                                    className={Styles['add-client-input-style']}
                                                    placeholder={t('ClientCanViewDocumentStatus')}
                                                    options={[
                                                        { label: t('Yes'), value: true },
                                                        { label: t('No'), value: false },
                                                    ]}
                                                    isSearchable={false}
                                                    onChange={(selectedOption) => handleChange('canSeeDocumentStatus', selectedOption.value)}
                                                    value={{
                                                        label: formData.canSeeDocumentStatus ? t('Yes') : t('No'),
                                                        value: formData.canSeeDocumentStatus,
                                                    }}
                                                    styles={customSelectStyles(false)}
                                                />
                                            </div>
                                        </>
                                    }

                                    {(isAccountant || isSubAccountant) && (
                                        <>
                                            <div className={`${Styles['form-row-item-3']} ${Styles['form-row-item-full']}`} style={{ width: '100%' }}>
                                                <div className={Styles['form-row-item-title3']}>
                                                    {t('SendClientWelcomeTitle')}
                                                </div>
                                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={!!formData.sendWelcomeEmail}
                                                                onChange={(e) => handleChange('sendWelcomeEmail', e.target.checked)}
                                                                name="sendWelcomeEmail"
                                                                color="primary"
                                                                disabled={!formData.ClientEmail || !validateEmail(formData.ClientEmail)}
                                                            />
                                                        }
                                                        label={t('SendClientWelcomeEmail')}
                                                    />
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={!!formData.sendWelcomeWhatsApp}
                                                                onChange={(e) => handleChange('sendWelcomeWhatsApp', e.target.checked)}
                                                                name="sendWelcomeWhatsApp"
                                                                color="primary"
                                                                disabled={!formData.ClientPhoneNumber || !validatePhoneNumber(formData.ClientPhoneNumber)}
                                                            />
                                                        }
                                                        label={t('SendClientWelcomeWhatsApp')}
                                                    />
                                                    {isEdit && (formData.sendWelcomeEmail || formData.sendWelcomeWhatsApp) && (
                                                        <TextField
                                                            fullWidth
                                                            placeholder={t('WelcomePasswordForNotification')}
                                                            value={formData.welcomePasswordForNotification}
                                                            onChange={(e) => handleChange('welcomePasswordForNotification', e.target.value)}
                                                            className={Styles['add-client-input-style']}
                                                            variant="standard"
                                                            type="password"
                                                            autoComplete="new-password"
                                                            sx={{ mt: 1 }}
                                                        />
                                                    )}
                                                    <Typography variant="caption" sx={{ color: 'text.secondary', mt: 0.5 }}>
                                                        {t('SendClientWelcomeHint')}
                                                    </Typography>
                                                </Box>
                                            </div>
                                            <div className={`${Styles['form-row-item-3']} ${Styles['form-row-item-full']}`} style={{ width: '100%' }}>
                                                <div className={Styles['form-row-item-title3']}>
                                                    {t('SendDocumentsSubmissionTitle')}
                                                </div>
                                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={!!formData.sendDocumentsInfoEmail}
                                                                onChange={(e) => handleChange('sendDocumentsInfoEmail', e.target.checked)}
                                                                name="sendDocumentsInfoEmail"
                                                                color="primary"
                                                                disabled={!formData.ClientEmail || !validateEmail(formData.ClientEmail)}
                                                            />
                                                        }
                                                        label={t('SendDocumentsSubmissionEmail')}
                                                    />
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={!!formData.sendDocumentsInfoWhatsApp}
                                                                onChange={(e) => handleChange('sendDocumentsInfoWhatsApp', e.target.checked)}
                                                                name="sendDocumentsInfoWhatsApp"
                                                                color="primary"
                                                                disabled={!formData.ClientPhoneNumber || !validatePhoneNumber(formData.ClientPhoneNumber)}
                                                            />
                                                        }
                                                        label={t('SendDocumentsSubmissionWhatsApp')}
                                                    />
                                                    <Typography variant="caption" sx={{ color: 'text.secondary', mt: 0.5 }}>
                                                        {t('SendDocumentsSubmissionHint')}
                                                    </Typography>
                                                </Box>
                                            </div>
                                        </>
                                    )}
                                    <div className={`${Styles['form-row-item-3']} ${Styles['form-row-item-full']}`}>
                                        <button
                                            onClick={() => handleClientSave(false)}
                                            disabled={!allFieldsFilled}
                                            className={`${Styles['save-client-button']} ${(showPackageSettings || showClientBusinessSettings) ? Styles['save-client-button-compact'] : Styles['save-client-button-default']}`}
                                            style={{
                                                background: allFieldsFilled ? '#304FFF' : '#D6D9FF',
                                                color: '#fff',
                                                cursor: allFieldsFilled ? 'pointer' : 'not-allowed',
                                                boxShadow: allFieldsFilled
                                                    ? '0px 6px 16px rgba(48, 79, 255, 0.3)'
                                                    : 'none',
                                            }}
                                            onMouseEnter={(e) => {
                                                if (allFieldsFilled) e.target.style.background = '#1E40FF';
                                            }}
                                            onMouseLeave={(e) => {
                                                if (allFieldsFilled) e.target.style.background = '#304FFF';
                                            }}
                                        >
                                            {isEdit ? t('Update') : t('save')}
                                        </button>
                                    </div>
                                </div>

                            </div>




                        </div>



                        {/* Add Button */}

                    </div>
                </>

                <SwitchPayerModal
                    open={showSwitchModal}
                    onClose={() => {
                        logPayerCard('SwitchPayerModal onClose');
                        setShowSwitchModal(false);
                        // If user cancelled adding a card, revert the payer selection to what it was before.
                        if (pendingPayerSwitchRef.current?.previousPaymentMethod !== null &&
                            pendingPayerSwitchRef.current?.previousPaymentMethod !== undefined) {
                            handleChange('clientPaymentMethod', pendingPayerSwitchRef.current.previousPaymentMethod);
                        }
                        pendingPayerSwitchRef.current = null;
                    }}
                    caseId={formData.CaseID || ''}
                    onSuccess={() => {
                        logPayerCard('SwitchPayerModal onSuccess → handleClientSave(true)');
                        setShowSwitchModal(false);
                        pendingPayerSwitchRef.current = null;
                        handleClientSave(true); // skip payerSwitched guard
                    }}
                />

                <RequestTransferModal
                    open={transferModalOpen}
                    onClose={() => setTransferModalOpen(false)}
                    caseId={formData.CaseID}
                    token={token}
                    clientDetails={{
                        caseId: formData.CaseID,
                        name: formData.ClientName,
                        phone: formData.ClientPhoneNumber,
                        email: formData.ClientEmail,
                        caseType: formData.CaseType,
                        reportingType: formData.ClientReportingType,
                    }}
                />

                <ClientBlockerWindow
                    open={showClientBlockerForEdit}
                    onClose={() => {
                        setShowClientBlockerForEdit(false);
                        pendingClientDataRef.current = null;
                    }}
                    client={{ caseId: formData.CaseID, name: formData.ClientName }}
                    token={token}
                    accountantId={user?.accountantId}
                    accountantName={user?.name}
                    userType={2}
                    showMoveButton={true}
                    onSuccess={async () => {
                        setShowClientBlockerForEdit(false);
                        const data = pendingClientDataRef.current;
                        pendingClientDataRef.current = null;
                        if (data && token) {
                            try {
                                const response = await ClientService.UpdateClient(token, data);
                                if (response?.ok) {
                                    await handleCaseRelationships(token, data.caseId, true);
                                    const updatedClient = await ClientService.GetClient(token, data.caseId);
                                    invalidateMainPageCache(data.accountantId);
                                    toast.success(t('CustomerUpdatedSuccessfully'));
                                    navigate('/client-details', { state: { client: updatedClient } });
                                } else {
                                    toast.error(t('FailedToUpdateCustomer'));
                                }
                            } catch (e) {
                                if (e?.body?.hasUnpaidBalance) {
                                    pendingClientDataRef.current = data;
                                    setShowClientBlockerForEdit(true);
                                } else {
                                    toast.error(e?.body?.message || t('FailedToUpdateCustomer'));
                                }
                            }
                        }
                    }}
                />

                <PartnersManagementModal
                    open={partnersModalOpen}
                    onClose={() => setPartnersModalOpen(false)}
                    caseId={formData.CaseID || ''}
                    token={token}
                    direction={direction}
                />
                {/* {isAccountant && (
                        <PasswordDialog
                            open={pwdDialogOpen}
                            onClose={() => {
                            setPwdDialogOpen(false);
                            setPwdValue("");
                            setPwdError("");
                            }}
                            onSubmit={() => {
                            if (!pwdValue) {
                                setPwdError(t("PasswordCannotBeEmpty"));
                                return;
                            }

                            // Do your logic here → e.g., add pwdValue to formData
                            handleChange("OfficePassword", pwdValue);

                            setPwdDialogOpen(false);
                            setPwdValue("");
                            setPwdError("");
                            }}
                            pwdValue={pwdValue}
                            setPwdValue={(val) => {
                            setPwdValue(val);
                            setPwdError("");
                            }}
                            dir={direction}
                            pwdError={pwdError}
                        />
                        )} */}

                <PasswordDialog
                    open={officePwdDialogOpen}
                    onClose={() => {
                        setOfficePwdDialogOpen(false);
                        setPwdError("");
                    }}
                    onSubmit={async () => {
                        if (!officePwd.value) {
                            setPwdError(t("PasswordCannotBeEmpty"));
                            return;
                        }
                        await saveOfficePassword();      // <- see next section
                        setOfficePwdDialogOpen(false);
                    }}
                    pwdValue={officePwd.value}
                    setPwdValue={(val) => setOfficePwd((p) => ({ ...p, value: val }))}
                    dir={direction}
                    pwdError={pwdError}
                    titleKey={officePwd.existsOnServer ? "ChangeOfficePassword" : "SetOfficePassword"}
                />
                {(isAccountant || isSubAccountant) && isEdit && (
                    <PasswordDialog
                        open={resetPwdDialogOpen}
                        onClose={() => {
                            setResetPwdDialogOpen(false);
                            setResetPwdError("");
                            setResetPwdValue("");
                        }}
                        onSubmit={async () => {
                            if (!resetPwdValue) {
                                setResetPwdError(t("PasswordCannotBeEmpty"));
                                return;
                            }
                            try {
                                const res = await ClientService.ResetClientPassword(token, formData.CaseID, resetPwdValue);
                                if (!res.ok) {
                                    const txt = await res.text();
                                    throw new Error(txt || 'Failed');
                                }
                                toast.success(t('ClientPasswordResetSuccess'));
                                setHasChangedInitialPassword(true);
                                setResetPwdDialogOpen(false);
                                setResetPwdValue("");
                            } catch (e) {
                                toast.error(t('ClientPasswordResetFailed'));
                            }
                        }}
                        pwdValue={resetPwdValue}
                        setPwdValue={(val) => {
                            setResetPwdValue(val);
                            setResetPwdError("");
                        }}
                        dir={direction}
                        pwdError={resetPwdError}
                        titleKey={"ResetClientPassword"}
                    />
                )}

                {(isClient) && (
                    <PasswordDialog
                        open={resetPwdDialogOpen}
                        onClose={() => {
                            setResetPwdDialogOpen(false);
                            setResetPwdError("");
                            setResetPwdValue("");
                            setOldResetPwdValue("");
                            setOldResetPwdError("");
                        }}
                        onSubmit={async () => {
                            // Validate old password
                            if (!oldResetPwdValue) {
                                setOldResetPwdError(t("PasswordCannotBeEmpty"));
                                return;
                            }
                            // Validate new password
                            if (!resetPwdValue) {
                                setResetPwdError(t("PasswordCannotBeEmpty"));
                                return;
                            }
                            try {
                                // Determine UserType and UserId based on who is logged in
                                let userId, userType;

                                if (isClient) {
                                    userId = formData.CaseID;
                                    userType = Constants.UserTypeInt.Client;
                                } else if (isSubAccountant) {
                                    userId = user?.subAccountantId;
                                    userType = Constants.UserTypeInt.SubAccountant;
                                }

                                // Use AuthService.resetPassword with appropriate UserType and OldPassword
                                const res = await AuthService.resetPassword(
                                    userId,
                                    resetPwdValue,
                                    userType,
                                    oldResetPwdValue
                                );
                                if (!res.ok) {
                                    const txt = await res.text();
                                    // Check if error is about incorrect old password
                                    if (res.status === 401 || txt.includes("incorrect")) {
                                        setOldResetPwdError(t("CurrentPasswordIsIncorrect"));
                                    } else {
                                        toast.error(txt || t('PasswordResetFailed'));
                                    }
                                    return;
                                }
                                toast.success(t('PasswordResetSuccess'));
                                if (isClient) {
                                    setHasChangedInitialPassword(true);
                                }
                                setResetPwdDialogOpen(false);
                                setResetPwdValue("");
                                setOldResetPwdValue("");
                            } catch (e) {
                                toast.error(t('PasswordResetFailed'));
                            }
                        }}
                        pwdValue={resetPwdValue}
                        setPwdValue={(val) => {
                            setResetPwdValue(val);
                            setResetPwdError("");
                        }}
                        oldPwdValue={oldResetPwdValue}
                        setOldPwdValue={(val) => {
                            setOldResetPwdValue(val);
                            setOldResetPwdError("");
                        }}
                        dir={direction}
                        pwdError={resetPwdError}
                        oldPwdError={oldResetPwdError}
                        titleKey={"ChangePassword"}
                        UserRole={isClient ? "Client" : isSubAccountant ? "SubAccountant" : null}
                    />
                )}
                <YearlyTaxAdvanceModal
                    open={yearlyTaxAdvanceModalOpen}
                    onClose={() => setYearlyTaxAdvanceModalOpen(false)}
                    caseId={formData.CaseID}
                    token={token}
                    t={t}
                    direction={direction}
                />
                <InitialClientPasswordModal
                    open={initialPasswordModalOpen}
                    onClose={closeInitialPasswordModal}
                    password={initialPasswordValue}
                    dir={direction}
                    showSuccessTitle={initialPasswordModalAfterCreate}
                />
                <DeleteUserDialog
                    open={openDeleteDialog}
                    onClose={handleCloseDeleteDialog}
                    t={t}
                    handleDeletePermanently={handleDeletePermanently}
                    handleInactiveUser={handleInactiveUser}
                />
                <ToastContainer />
                {loading && (
                    <div className="loader-container">
                        <PuffLoader
                            size={100}        // Larger size for better visibility
                            loading={loading}
                        />
                    </div>
                )}
            </>
        </>
    );
};

export default AddClient;